import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { GlobalService } from '../service/global.service';
import { LookupInfo } from '../model/lookup.model';
import { ProjectSaleInfo } from '../model/projectsale.model';
import { HttpHeaders, HttpClient, HttpEventType } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import {
  environment
} from 'src/environments/environment';
import { ProjectSaleAttachmentInfo } from '../model/projectsaleattachment.model';
import { ProjectSaleActivityLogNoteInfo } from '../model/projectsaleactivitylognote.model';
import { ProjectSaleBudgetInfo } from '../model/ProjectSaleBudget.model';
import { ProjectSaleBudgetAttachedFileInfo } from '../model/ProjectSaleBudgetAttachedFile.model';
import { ProjectSaleCostInfo } from '../model/ProjectSaleCost.model';
import { ProjectSaleCostAttachedmentInfo } from '../model/ProjectSaleCostAttachedment.model';
import { FormGroup, FormBuilder, Validators, FormControl, Form, FormArray } from '@angular/forms';
import { Observable } from 'rxjs';
import { flatMap } from 'rxjs/operators';
import { async } from 'rxjs';
import { data } from 'jquery';
import { ProjectGroupInfo } from '../model/ProjectGroupInfo';
import { TokenService } from '../service/token.service';
import { StateInfo } from '../model/StateInfo.model';
import { SubStateInfo } from '../model/SubStateInfo.model';
import { StateMappingInfo } from '../model/StateMappingInfo.model';
import { ProjectPipelineInfo } from '../model/projectpipeline.model';
import { variable } from '@angular/compiler/src/output/output_ast';
import { EmpInfo } from '../model/emp.model';
import { ProjectMemberInfo } from '../model/projectmember.model';
import { EffortGroupInfo } from '../model/effortgroup.model';
import { ProjectSaleQuotationInfo } from 'src/app/model/ProjectSaleQuotationInfo.model';
import { QuotationInfo } from 'src/app/model/QuotationInfo.model';
import { QuotationProductInfo } from 'src/app/model/QuotationProductInfo.model';
import { ProjectSaleQuotationAttachmentInfo } from 'src/app/model/ProjectSaleQuotationAttachmentInfo.model';

@Component({
  selector: 'app-information-lead',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './information-lead.component.html',
  styleUrls: ['./information-lead.component.css']
})
export class InformationLeadComponent implements OnInit {

  _EmpCode: string;

  // Form Group Master
  InformationForm: FormGroup;

  form: FormGroup;

  // Form Group for Assign Member
  AssignMemberForm: FormGroup;
  // array control Assign Member
  itemsAssignMemberForm_array: FormArray;
  // array of remove AssignMember
  //itemsRemoveAssignMember_array: ProjectMemberInfo[] = [];
  // Emp List for Assign Member
  EmployeeList: EmpInfo[] = [];
  // Lookup MASTERPROJECTROLE List for Assign Member
  PositionInProjectList: LookupInfo[] = [];

  // Assign Member Lead List
  AssignMemberLeadList: ProjectMemberInfo[] = [];

  // flag display for BD and State Approve Lead Only
  IsShowForThisBDOnlyANDStateApproveLead: boolean;

  // Emp Manager current project
  EmpManager: string

  // Zone Rest API variable
  baseurl: string;
  expense_baseurl: string;

  // variable for loading
  displayloading: boolean = false;
  Msgloadding: string = '';
  // variable flag insert update
  isSubmitted: any;
  isProjectSaleBudgetAttachedFileSubmitted: any;
  isProjectSaleCostAttachedmentSubmitted: any;
  isProjectSaleQuotationAttachedmentSubmitted: any;
  // project sale id from parameter
  @Input() ProjectSaleID: string;
  @Input() isViewOnly: boolean = false;
  _ParamProjectSaleID: string

  // variable modal
  titlemodal: string
  detailmodal: string

  CloseddealprogressList: LookupInfo[] = []

  // variable Update
  ProjectPipelineitem: ProjectPipelineInfo;

  // variable Information form
  ProjectSaleStateCode: string
  ProjectSaleCloseDealProgress: string
  ProjectSaleState: string

  ProjectSaleSubState: string

  ProjectSaleStatusDisplay: string
  ProjectSaleTypeDisplay: string
  ProjectSaleCategoryName: string
  ProjectSaleTool: string
  ProjectSalePhaseDisplay: string
  ProjectSaleBudget: number
  ProjectSaleYear: string

  ProjectSaleCreateBy: string
  ProjectSaleDisplayCreateBy: string

  ProjectSaleAssignTo: string
  ProjectSaleDisplayAssignTo: string

  ProjectSaleName: string
  ProjectSaleContactPerson: string
  ProjectSaleContactPosition: string
  ProjectSaleContactPersonPosition: string
  ProjectSaleCompanyDisplay: string
  ProjectSaleCompanyCode: string
  ProjectSaleCode: string
  ProjectSaleRemark: string
  ProjectSaleContactTel: string
  ProjectSaleContactEmail: string
  ProjectSaleContactDate: string
  ProjectSaleDeliveryAddress: string
  ProjectSaleTaxInvoiceAddress: string
  hideProjectSaleRequestType: string
  txtFlagProjectLead: boolean
  ckFlagProjectLead: number

  ProjectSaleTeamCode: string
  ProjectSaleTeamCodeDisplay: string
  ProjectSaleCloseDealComment: string

  // variable about confirm change status
  confirmselectedstatus: string = "";
  confirmselectedstatuscode: string = "";

  // variable about confirm remove attach file
  confirmselectedAttachFileName: string = "";
  confirmselectedAttachFileId: number = 0;


  //variable about Team
  ProjectSaleSupportTeam: string = '';


  // variable about modal add address
  ProjectSaleCompanyDeliveryAddressdefault: string = "";
  ProjectSaleCompanyTaxInvoiceAddressdefault: string = "";
  ProjectSaleCompanyDeliveryAddress: string = "";
  ProjectSaleCompanyTaxInvoiceAddress: string = "";
  FlagDisabledAddress: boolean = true;

  // ---------- variable about Activity log & note Zone ------------------
  ProjectSaleActivityNote: string = "";
  // Zone pagination variable Activity log & note Zone
  public indexNo: number = 0
  public currentPageNumber: number = 1
  public ProjectSaleActivityNoteTotal: number
  public totalPages: number
  public SizePage: number

  // ProjectSaleActivityLogNote List
  ProjectSaleActivityLogNoteList: ProjectSaleActivityLogNoteInfo[]


  // ---------------- End variable about Activity log & note Zone ----------------

  // list project sale
  ProjectSaleList: ProjectSaleInfo[]

  // list attach file project sale
  ProjectSaleAttachmentList: ProjectSaleAttachmentInfo[] = [];

  // ProjectSaleBudget List & Variable Item
  public currentPageProjectSaleBudgetNumber: number = 1
  public ProjectSaleBudgetTotal: number
  public totalProjectSaleBudgetPages: number

  ProjectSaleBudgetList: ProjectSaleBudgetInfo[] = [];
  ProjectSaleBudgetListPromise: Promise<ProjectSaleBudgetInfo[]>
  public hidcouchk: string;

  ProjectSaleBudgetAttachedFileList: ProjectSaleBudgetAttachedFileInfo[]

  txtProjectSaleBudgetGLName: string
  txtProjectSaleBudgetAmount: number

  validatetxtProjectSaleBudgetGLName: string
  validatetxtProjectSaleBudgetAmount: string

  ProjectSaleBudgetGLList: LookupInfo[]

  projectsaleBudgetFilesToUpload: File[];
  projectsaleBudgetPathFile: string = '';

  projectsaleCostFilesToUpload: File[];
  projectsaleCostPathFile: string = '';

  validatetxtProjectSaleCostItemCode: string
  validatetxtProjectSaleCostItemName: string
  validatetxtProjectSaleCostType: string
  validatetxtProjectSaleCostQuantity: string
  validatetxtProjectSaleCostUnitCost: string

  IsClearList: string = ';'
  IsClearProjectSaleCostAttachedmentList: string = ';';
  IsClearProjectSaleQuotationAttachedmentList: string = '';

  isOnUpdate: boolean;
  projectsalebudgetinsupdflag: boolean;
  projectsalebudgetid: number
  hidprojectsalebudgetId: number

  modalDocName: string;
  modalDocInfo: any;

  // ProjectSaleCost List and variable item
  ProjectSaleCostList: ProjectSaleCostInfo[] = [];
  public currentPageProjectSaleCostNumber: number = 1
  public totalProjectSaleCostPages: number
  public ProjectSaleCostTotal: number

  ProjectSaleCostAttachedmentList: ProjectSaleCostAttachedmentInfo[]
  ProjectSaleCostTypeList: LookupInfo[]

  txtProjectSaleCostItemCode: string
  txtProjectSaleCostItemName: string
  txtProjectSaleCostType: string
  txtProjectSaleCostQuantity: number
  txtProjectSaleCostUnit: string
  txtProjectSaleCostUnitCost: number
  txtProjectSaleCostAmount: number
  hidprojectsalecostId: number

  // variable about upload file
  public itragetuploadstart: number = 0;
  public itragetuploadprogress: number = 0;

  ListSubState: StateMappingInfo[] = [];
  ListPipeline: LookupInfo[] = [];
  monthNameslist: any;
  yearlist: any[];
  PriorityList: LookupInfo[] = [];

  // close deal
  CloseDealWarning: string = '';
  CloseDealSubState: string = '';


  // access_token for query parameter
  access_token: string;

  //empselect
  employeeselectrun: boolean = false;
  employeeselectreturnto: number;
  selectedemp: EmpInfo;

  ListEffortGroup: EffortGroupInfo[] = [];

  currentCloseDealType: string = '';

  VisibleTab: boolean = false;
  isShowTabSellingCost: boolean = false;
  isShowTabAssignMember: boolean = true;

  // ------------------------------- Assign Manager Zone -----------------------------------------------
  AssignLeadForm: FormGroup
  AssignLeadList: any[] = [];

  // -------------------------------- Quotattion Setting Zone ------------------------------------------
  //formProjectSaleQuotation: FormGroup;
  IsQuotationAttach: boolean = false;
  ProjectSaleQuotaionList: ProjectSaleQuotationInfo[] = []; 
  hidProjectSaleQuotaionID: number

  isOnUpdateProjectSaleQuotation: boolean;
  duplicateQuotationError: boolean = false;
  _RoleCode: string;

  QuotationList: QuotationInfo[] = [];
  QuotationProductList: QuotationProductInfo[] = [];
  ProjectSaleQuotationAttachedmentList: ProjectSaleQuotationAttachmentInfo[] = [];

  projectsaleQuotationFilesToUpload: File[];
  projectsaleQuotationPathFile: string = '';

  ProjectPipeLineQuoStatusList: ProjectPipelineInfo[] = [];

  constructor(private httpClient: HttpClient, private GlobalService: GlobalService, private router: ActivatedRoute, private router2: Router, private formBuilder: FormBuilder, private TokenService: TokenService) {
    this.baseurl = environment.base_api;
    this.expense_baseurl = environment.expense_base_api;
    //GlobalService.CheckPagingAccessRights();
  }

  async ngOnInit() {

    this.access_token = await this.TokenService.RefreshToken();

    this._EmpCode = localStorage.getItem('EmpCode');

    this.SizePage = environment.PageSizeSmall;

    this.monthNameslist = ["January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];

    this.yearlist = this.generateArrayOfYears();


    // create control Price
    this.InformationForm = this.formBuilder.group({
      PriceTimeForm: this.formBuilder.group({
        ProjectSaleEstimatePrice: [null],
        ProjectSaleActualPrice: [null],
        ProjectSaleEstimateTime: [null],
        PorjectSaleCommission: [null],
        Commissiontotal: [null],
        ProjectStartDealDate: [null],
        ProjectEndDealDate: [null],
      },
        {
          // Used custom form validator
          validator: [this.checkdate("ProjectStartDealDate", "ProjectEndDealDate")]
        }),
      UpdateForm: this.formBuilder.group({
        ProjectSaleSubState: [null, Validators.required],
        Pipeline: [null, Validators.required],
        ProjectSaleExpectedClosePeriodMonth: [null, Validators.required],
        ProjectSaleExpectedClosePerioddYear: [null, Validators.required],
        Priority: [null, Validators.required],
        WinRate: [null, Validators.required],
        Remark: [null],
      }),
      CloseDealForm: this.formBuilder.group({
        EffortGroup: [null],
        Comment: [null],
      }),
      AssignMemberForm: this.formBuilder.group({
        items: this.formBuilder.array([this.createItemAssignMemberDefault()]),
        txtFlagProjectLead: [false]
      }),
      AssignLeadForm: this.formBuilder.group({
        ddlAssignLead: [null]
      }),
      formProjectSaleQuotation: this.formBuilder.group({
        txtQuotationNo: [null],
        QuotationNoSelect: [''],
        quotationType: ['1', Validators.required],
        txtPrice: [null, Validators.required],
        selectActiveFlag: [null, Validators.required]
      }),
    });

    // set Assign Lead Form
    this.AssignLeadForm = this.InformationForm.get('AssignLeadForm') as FormGroup;

    // set AssignMemberForm from InformationForm
    this.AssignMemberForm = this.InformationForm.get('AssignMemberForm') as FormGroup

    // get items array to itemsAssignMemberForm_array
    this.itemsAssignMemberForm_array = this.AssignMemberForm.get('items') as FormArray;

    this.form = this.formBuilder.group({
      txtProjectSaleBudgetGLName: [null, Validators.required],
      txtProjectSaleBudgetAmount: [null, Validators.required]
    });

    // Part validate quotaton no
      this.formProjectSaleQuotation.get('quotationType').valueChanges.subscribe(value => {
        console.log('--- DEBUG: In valueChanges - quotationType changed to:', value);
      this.updateQuotationTypeValidation(value);
    });

    // Call 1 time after formcontrol enable and set follow default
      this.updateQuotationTypeValidation(this.formProjectSaleQuotation.get('quotationType').value);
    // Part validate quotaton no

    // Detect value change of QuotationNoSelect
    this.formProjectSaleQuotation.get('QuotationNoSelect')?.valueChanges.subscribe(value => {
      this.duplicateQuotationError = false;
      if (value) {
        (async () => {  
          const quotationType = this.formProjectSaleQuotation.get('quotationType')?.value;
      const txtQuotationNo = this.formProjectSaleQuotation.get('txtQuotationNo')?.value?.trim();
      const selectQuotationNo = value?.trim(); // ← ได้จาก value change โดยตรง

      const quotationNo = quotationType === '1' ? txtQuotationNo : selectQuotationNo;

      const isDuplicate = this.ProjectSaleQuotaionList.some(
        q => q.ProjectSaleQuotationNo === quotationNo
      );

      this.duplicateQuotationError = isDuplicate;

      if (isDuplicate) {
        return; // หยุดไม่ต้องทำงานต่อ
      }




          const selectedQuotation = this.QuotationList.find(q => q.QuotationNo === value);

          //console.log('selectedQuotation.QuotationID', selectedQuotation.QuotationID);
          const quotationProducts = await this.LoadQuotationProductList(selectedQuotation.QuotationID); // ← ต้องรอ
          //console.log('quotationProducts!!', quotationProducts);
            
          const totalNet = quotationProducts.reduce((sum, item) => sum + (item.NetAmountPrice ?? 0), 0);

          this.formProjectSaleQuotation.patchValue({txtPrice: totalNet});
          
          //const quotationType = this.formProjectSaleQuotation.get('quotationType')?.value;
          })();
        }
    });
    // Detect value change of QuotationNoSelect

    await this.GlobalService.loadLookup('PROJECTSALECLOSEDEALPROGRESS').then((data) => {
      this.CloseddealprogressList = data;
    });

    this.router.params.subscribe(params => {
      // Use the input parameter if provided, otherwise use the route parameter
      this._ParamProjectSaleID = this.ProjectSaleID || params['ProjectSaleID'];
    });

    // load sub state
    this.LoadFollowupSubState();
    // load priority list
    this.loadLookup('ISSUEPRIORITY').then((data) => {
      this.PriorityList = data;
    })



    // Load log
    await this.OnLoadProjectSaleActivityLogNoteList();
    await this.OnLoadCountProjectSaleActivityLogNoteList();

    // load information
    await this.LoadInformationFromId();

    this.loadEffortGroup().then((data) => {
      this.ListEffortGroup = data;
    });

    await this.loadLastUpdate().then((data) => {
      this.ProjectPipelineitem = data;

      if (this.ProjectPipelineitem.ProjectSaleCode != null && this.ProjectPipelineitem.ProjectSaleCode != '') {
        this.InformationForm.get('UpdateForm').patchValue({
          ProjectSaleSubState: this.ProjectPipelineitem.ProjectPipelineSubStateCode != null ? this.ProjectPipelineitem.ProjectPipelineSubStateCode : null,
          Pipeline: this.ProjectPipelineitem.ProjectPipelineStatusLookupCode != null ? this.ProjectPipelineitem.ProjectPipelineStatusLookupCode : null,
          Priority: this.ProjectPipelineitem.ProjectPipelinePriority != null ? this.ProjectPipelineitem.ProjectPipelinePriority : null,
          WinRate: this.ProjectPipelineitem.ProjectPipelineProbability != null ? this.ProjectPipelineitem.ProjectPipelineProbability : null,
          Remark: this.ProjectPipelineitem.ProjectPipelineRemark != null ? this.ProjectPipelineitem.ProjectPipelineRemark : null,
        });
      }

    });

    this.LoadProjectSaleAttachfileList().then(data => {
      this.ProjectSaleAttachmentList = data;

      // set progress 100 for attach file from database
      this._RoleCode = localStorage.getItem("EmpRoleCode");
      this.ProjectSaleAttachmentList.forEach((item, index) => {
        item.progress = 100;
      });
    });



    this.validatetxtProjectSaleBudgetGLName = 'False';
    this.validatetxtProjectSaleBudgetAmount = 'False';
    this.validatetxtProjectSaleCostItemCode = 'False';
    this.validatetxtProjectSaleCostItemName = 'False';
    this.validatetxtProjectSaleCostType = 'False';
    this.validatetxtProjectSaleCostQuantity = 'False';
    this.validatetxtProjectSaleCostUnitCost = 'False';

    this.loadLookup('PROJECTSALEGLCODE').then((data) => {
      this.ProjectSaleBudgetGLList = data;
    })
    this.loadLookup('PROJECTSALEEXPENSE').then((data) => {
      this.ProjectSaleCostTypeList = data;
    })



    this.LoadProjectSaleBudget();
    this.OnLoadCountProjectSaleBudgetList();
    this.IsClearList = "false";
    this.IsClearProjectSaleCostAttachedmentList = "false";

    this.LoadProjectSaleCost();
    this.OnLoadCountProjectSaleCostList();


    // load pipeline status
    await this.loadPipelineStatus();

    // ------------------- Assign Member Zone -------------------------------
    // Load Assgin Member
    await this.loadAssignMemberLead();
    // Load Emp List for Assign Member
    await this.loadEmpList();
    // Load PositionInProject (Lookup MASTERPROJECTROLE) for Assgin Member
    await this.GlobalService.loadLookup('MASTERPROJECTROLE').then((data) => {
      // Remove Lookup Business Development from data on object property LookupCode = 5
      data = data.filter(function (obj) {
        return obj.LookupCode !== '5';
      });

      this.PositionInProjectList = data;
    });

    //Load Active Project Member
    await this.loadCountActiveProjectMember();

    // ------------------- Assign Member Zone -------------------------------

    // Quotation Setting Zone //
    
    await this.LoadQuotationList();
    await this.LoadProjectSaleQuotaionList();

  }


  async btnAssignLeadClick() {
    // reset form
    this.AssignLeadForm.reset();
    // load ddl AssignPM
    await this.loadDDLAssignLead();

    // set current Assign PM
    this.AssignLeadForm.patchValue({
      ddlAssignLead: this.ProjectSaleList[0].ProjectSaleAssignTo,
    });

    // show modal Assign BD
    $('#ModalAssign').modal();
  }
  

  async loadDDLAssignLead() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['SaleTeamCode'] = this.ProjectSaleList[0].ProjectSaleTeamCode;  // Business Development
      objectjson['AssignedSellerOnly'] = true;

      let strjson = JSON.stringify(objectjson);

      await this.httpClient.post<any[]>(this.baseurl + "Team/GetEmpMappingTeam", strjson, httpOptions)
        .toPromise().then((data) => {
          this.AssignLeadList = data;
        });
    }
  }


  async btnSubmitAssignLeadClick() {
    if (this.AssignLeadForm.valid) {
      // hide modal Assign BD
      $('#ModalAssign').modal('hide');

      // save AssignPM
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {

        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };
        var EmpAssignLead = this.AssignLeadForm.get('ddlAssignLead').value;
        var EmpRoleAssignLead = $('#selectAssignLead option:selected').attr('emprolecode');

        var objectjson = {};
        objectjson['EmpCode'] = this.checkUndefinedString(EmpAssignLead.toString());
        // objectjson['EmpRole'] = this.checkUndefinedString(EmpRoleAssignLead.toString());
        objectjson['ProjectCode'] = this.checkUndefinedString(this.ProjectSaleList[0].ProjectSaleCode);
        objectjson['ProjectType'] = 'Lead';
        objectjson['PositionInProject'] = '5'; // from lookup MASTERPROJECTROLE 5 = Business Development

        objectjson['UpdateBy'] = this.checkUndefinedString(localStorage.getItem("EmpCode"));

        let strjson = JSON.stringify(objectjson);


        this.isSubmitted = await this.httpClient.post<ProjectMemberInfo[]>(this.baseurl + "ProjectMember/SaveAssignManagerProject", strjson, httpOptions)

          .subscribe(result => this.isSubmitted = result, failCb => {
            console.log("Update fail")
            this.titlemodal = 'Update Assign fail.';
            this.detailmodal = 'Action Assign Lead was update fail.';

            $('#ModalError').modal();

          },
            async () => {
              console.log("Update = " + this.isSubmitted)

              this.titlemodal = 'Submit Assign Lead succeed.';
              this.detailmodal = 'Update Assign Lead completed.';

              $('#ModalComplate').modal();

              // load information
              await this.LoadInformationFromId();

            }
          )

      }

    } else {
      //mark FormGroup Touched
      this.GlobalService.validateAllFormFields(this.AssignLeadForm)

    }

  }

  btnClick_changeclosedealtype(clasedealtype) {
    this.InformationForm.get('CloseDealForm').reset();
    var closedealfrom = this.InformationForm.get('CloseDealForm') as FormGroup;
    closedealfrom.controls['Comment'].clearValidators();
    closedealfrom.controls['Comment'].updateValueAndValidity();
    closedealfrom.controls['EffortGroup'].clearValidators();
    closedealfrom.controls['EffortGroup'].updateValueAndValidity();
    if (clasedealtype == '1-5-1') { // Close Won
      this.CloseDealWarning = 'Lead Information can no longer be changed after closing.';
      closedealfrom.controls['Comment'].setValidators(Validators.required);
      closedealfrom.controls['Comment'].updateValueAndValidity();
      // closedealfrom.controls['EffortGroup'].setValidators(Validators.required);
      // closedealfrom.controls['EffortGroup'].updateValueAndValidity();

    } else if (clasedealtype == '1-5-2') { // Close Lost
      this.CloseDealWarning = 'Lead Information can no longer be changed after closing.';
    } else if (clasedealtype == '1-5-3') { // Withdraw
      this.CloseDealWarning = 'Lead Information can no longer be changed after closing.';
    } else if (clasedealtype == '1-5-4') { // Terminate
      this.CloseDealWarning = 'Lead Information can no longer be changed after closing.';
    }
    $('.box-closedealtype').removeClass('active'); // remove all active
    $('[closedealtype="' + clasedealtype + '"]').addClass('active'); // add active current select
    this.CloseDealSubState = clasedealtype;

    this.currentCloseDealType = clasedealtype;
    console.log('CloseDealSubState!! = ' + this.CloseDealSubState);
    console.log('currentCloseDealType!! = ' + this.currentCloseDealType);
  }

  btnClick_returnPipeline() {
    this.InformationForm.get('UpdateForm').reset();
    // set ProjectSaleExpectedClosePeriodMonth , ProjectSaleExpectedClosePerioddYear from database
    this.InformationForm.get('UpdateForm').patchValue({
      ProjectSaleExpectedClosePeriodMonth: this.ProjectSaleList[0].ProjectSaleClosedPeriodMonth != null ? parseInt(this.ProjectSaleList[0].ProjectSaleClosedPeriodMonth) : null,
      ProjectSaleExpectedClosePerioddYear: this.ProjectSaleList[0].ProjectSaleClosedPeriodYear != null ? parseInt(this.ProjectSaleList[0].ProjectSaleClosedPeriodYear) : null,
    });
  }

  async btnClick_SavePipeline() {
    if (this.InformationForm.get('UpdateForm').valid) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };

        var objectjson = {};
        objectjson['ProjectSaleId'] = this._ParamProjectSaleID;
        objectjson['ProjectSaleState'] = '1-4'; // Follow up
        objectjson['ProjectSaleSubState'] = this.InformationForm.get('UpdateForm').get('ProjectSaleSubState').value;
        objectjson['ProjectSaleClosedPeriodMonth'] = this.InformationForm.get('UpdateForm').get('ProjectSaleExpectedClosePeriodMonth').value;
        objectjson['ProjectSaleClosedPeriodYear'] = this.InformationForm.get('UpdateForm').get('ProjectSaleExpectedClosePerioddYear').value;
        objectjson['ProjectSaleUpdateBy'] = this.checkUndefinedString(localStorage.getItem("EmpCode"));
        objectjson['ProjectSaleTeamCode'] = this.ProjectSaleTeamCode;

        let strjson = JSON.stringify(objectjson);


        this.isSubmitted = this.httpClient.post<ProjectSaleInfo[]>(this.baseurl + "ProjectSale/UpdateProjectSale", strjson, httpOptions)

          .subscribe(result => this.isSubmitted = result, failCb => {
            console.log("Update fail");
            this.titlemodal = 'Update fail.';
            this.detailmodal = 'Your lead was Update fail.';
            $('#ModalError').modal();
          },
            async () => {
              console.log("Update Project Sale = " + this.isSubmitted);
              await this.InsertPipeline();

            }
          );

        await this.loadPipelineStatus();
      }
    } else {
      this.GlobalService.validateAllFormFields(this.InformationForm.get('UpdateForm') as FormGroup);
    }
  }

  async InsertPipeline() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

      objectjson['ProjectSaleCode'] = this.ProjectSaleCode;
      objectjson['ProjectPipelineSubStateCode'] = this.InformationForm.get('UpdateForm').get('ProjectSaleSubState').value;
      objectjson['ProjectPipelineStatusLookupCode'] = this.InformationForm.get('UpdateForm').get('Pipeline').value;
      objectjson['ProjectPipelineClose'] = new Date(this.InformationForm.get('UpdateForm').get('ProjectSaleExpectedClosePerioddYear').value + '-' + (this.InformationForm.get('UpdateForm').get('ProjectSaleExpectedClosePeriodMonth').value.toString()).padStart(2, '0'));
      objectjson['ProjectPipelineAmount'] = this.ProjectSaleList[0].ProjectSaleActualPrice != null ? this.ProjectSaleList[0].ProjectSaleActualPrice : 0
      objectjson['ProjectPipelineComission'] = this.ProjectSaleList[0].PorjectSaleCommission != null ? this.ProjectSaleList[0].PorjectSaleCommission : 0
      objectjson['ProjectPipelinePriority'] = this.checkUndefinedString(this.InformationForm.get('UpdateForm').get('Priority').value)
      objectjson['ProjectPipelineProgress'] = this.ProjectSaleList[0].ProjectSaleCloseDealProgress != null ? this.ProjectSaleList[0].ProjectSaleCloseDealProgress : ''
      objectjson['ProjectPipelineProbability'] = parseInt(this.InformationForm.get('UpdateForm').get('WinRate').value)
      objectjson['ProjectPipelineRemark'] = this.checkUndefinedString(this.InformationForm.get('UpdateForm').get('Remark').value)
      objectjson['ProjectPipelineCreateBy'] = this.checkUndefinedString(localStorage.getItem("EmpCode"));
      objectjson['ProjectPipelineFlagDelete'] = "N";


      let strjson = JSON.stringify(objectjson);


      this.isSubmitted = this.httpClient.post<ProjectPipelineInfo[]>(this.baseurl + "ProjectPipeline/InsertProjectPipeline", strjson, httpOptions)

        .subscribe(result => this.isSubmitted = result, failCb => {
          console.log("Update fail");
          this.titlemodal = 'Update fail.';
          this.detailmodal = 'Your lead was Update fail.';
          $('#ModalError').modal();
        },
          async () => {
            console.log("Insert Pipeline = " + this.isSubmitted);
            //this.btnClick_returnPipeline();
            this.titlemodal = 'Successfully';
            this.detailmodal = 'You update status lead successfully.';
            $('#ModalComplate').modal();

          }
        )


    }

  }

  async loadPipelineStatus() {
    await this.loadLookup('PIPELINESTATUS').then((data) => {
      // Filter pipeline options to only show those with LookupCode less than current status
      const currentStatus = this.InformationForm.get('UpdateForm').get('Pipeline').value;

      // console.log("Current status: ", currentStatus);
      // if (currentStatus) {
      //   this.ListPipeline = data.filter(item => item.LookupCode >= currentStatus);
      // } else {
      //   this.ListPipeline = data;
      // }

      this.ListPipeline = data.slice(0, -1); //remove last item (closed)
    })
  }

  // load last pipeline
  async loadLastUpdate() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

      objectjson['ProjectSaleCode'] = this.ProjectSaleCode

      let strjson = JSON.stringify(objectjson);

      return await this.httpClient.post<ProjectPipelineInfo>(this.baseurl + "ProjectPipeline/GetLastProjectPipeline", strjson, httpOptions)
        .toPromise()
    }
  }

  generateArrayOfYears() {
    var max = new Date().getFullYear() + 5
    var min = max - 5
    var years = []

    for (var i = max; i >= min; i--) {
      years.push(i)
    }
    return years
  }

  //reset value Price & Time to default
  ResetvaluePriceTime() {
    // get value Price & Time Zone
    this.InformationForm.get('PriceTimeForm').patchValue({
      ProjectSaleEstimatePrice: this.ProjectSaleList[0].ProjectSaleEstimatePrice != null ? this.ProjectSaleList[0].ProjectSaleEstimatePrice : 0,
      ProjectSaleActualPrice: this.ProjectSaleList[0].ProjectSaleActualPrice != null ? this.ProjectSaleList[0].ProjectSaleActualPrice : 0,
      ProjectSaleEstimateTime: this.ProjectSaleList[0].ProjectSaleEstimateTime != null ? this.ProjectSaleList[0].ProjectSaleEstimateTime : 0,
      PorjectSaleCommission: this.ProjectSaleList[0].PorjectSaleCommission != null ? parseInt(this.ProjectSaleList[0].PorjectSaleCommission) : 0,
      ProjectStartDealDate: this.ProjectSaleList[0].ProjectStartDealDate != null ? this.GlobalService.formatDate(this.ProjectSaleList[0].ProjectStartDealDate) : null,
      ProjectEndDealDate: this.ProjectSaleList[0].ProjectEndDealDate != null ? this.GlobalService.formatDate(this.ProjectSaleList[0].ProjectEndDealDate) : null,
    });
    this.GetCommissionActualPrice();
    
    // Format the price fields after setting values
    setTimeout(() => {
      this.replaceCommas(this.InformationForm.get('PriceTimeForm').get('ProjectSaleEstimatePrice'));
      this.replaceCommas(this.InformationForm.get('PriceTimeForm').get('ProjectSaleActualPrice'));
    }, 0);
  }

  // Call Rest api for load Sub State fix Follow up only
  async LoadFollowupSubState() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

      objectjson['StateCode'] = '1-4';  // Follow Up
      objectjson['FlagActive'] = 'Y';



      let strjson = JSON.stringify(objectjson);

      return this.httpClient
        .post<StateMappingInfo[]>(this.baseurl + "MasterSale/GetMappingStateStatusList",
          strjson, httpOptions)
        .toPromise().then(data => {
          this.ListSubState = data;
        });
    }
  }


  // Call Rest api for load ProjectSale list by projectsaleid
  async LoadProjectSaleList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

      objectjson['ProjectSaleId'] = this._ParamProjectSaleID;


      let strjson = JSON.stringify(objectjson);

      return this.httpClient
        .post<ProjectSaleInfo[]>(this.baseurl + "ProjectSale/GetProjectSale",
          strjson, httpOptions)
        .toPromise()
    }
  }

  // Call Rest api for load ProjectSale Attach file list by projectsaleid
  async LoadProjectSaleAttachfileList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

      objectjson['ProjectSaleId'] = this._ParamProjectSaleID;


      let strjson = JSON.stringify(objectjson);

      return this.httpClient
        .post<ProjectSaleAttachmentInfo[]>(this.baseurl + "ProjectSaleAttachment/GetProjectSaleAttachment",
          strjson, httpOptions)
        .toPromise()
    }
  }

  // Call load ProjectSaleActivityLogNote List  by projectsaleid
  OnLoadProjectSaleActivityLogNoteList(traget = null) {

    // check call function from change page or onloadfrist
    if (traget != null) {
      this.LoadProjectSaleActivityLogNoteUpdatePagination(traget);
    }

    //call Rest api for load ProjectSaleActivityLogNote List  by projectsaleid
    this.LoadProjectSaleActivityLogNoteList().then(data => {
      this.ProjectSaleActivityLogNoteList = data;
      console.log(data);
      if (this.ProjectSaleActivityLogNoteList.length == 0) {
        this.currentPageNumber = 0;
      }
    })
  }

  OnLoadCountProjectSaleActivityLogNoteList() {

    //call function load count all ProjectSale list on hand current user
    this.LoadCountProjectSaleActivityLogNoteList().then(data => {
      this.ProjectSaleActivityNoteTotal = data;
      if (this.ProjectSaleActivityNoteTotal == 0) this.currentPageNumber = 0;
      this.totalPages = Math.ceil(this.ProjectSaleActivityNoteTotal / this.SizePage);

    })
  }

  // Call Rest api for load ProjectSaleActivityLogNote List  by projectsaleid
  async LoadProjectSaleActivityLogNoteList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumber - 1) * this.SizePage;
      var objectjson = {};

      objectjson['ProjectSaleId'] = this._ParamProjectSaleID;

      objectjson['rowFetch'] = this.SizePage;
      objectjson['rowOFFSet'] = offset;

      let strjson = JSON.stringify(objectjson);

      return this.httpClient
        .post<ProjectSaleActivityLogNoteInfo[]>(this.baseurl + "ProjectSaleActivityLogNote/GetProjectSaleActivityLogNote",
          strjson, httpOptions)
        .toPromise()
    }
  }

  // Call Rest api for Count ProjectSaleActivityLogNote List  by projectsaleid
  async LoadCountProjectSaleActivityLogNoteList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

      objectjson['ProjectSaleId'] = this._ParamProjectSaleID;

      let strjson = JSON.stringify(objectjson);

      return this.httpClient
        .post<number>(this.baseurl + "ProjectSaleActivityLogNote/GetCountProjectSaleActivityLogNote",
          strjson, httpOptions)
        .toPromise()
    }
  }

  // check param and load data
  async LoadInformationFromId() {
    if (this._ParamProjectSaleID != null && this._ParamProjectSaleID != '') {
      //call function load ProjectSale list by project sale id
      await this.LoadProjectSaleList().then(data => {
        this.ProjectSaleList = data;

        // count check project sale list
        if (this.ProjectSaleList.length != 0) {

          this.ProjectSaleState = this.ProjectSaleList[0].ProjectSaleState;
          this.ProjectSaleStatusDisplay = this.ProjectSaleList[0].ProjectSaleStatusDisplay;
          this.ProjectSaleTypeDisplay = this.ProjectSaleList[0].ProjectSaleTypeDisplay;
          this.ProjectSaleCategoryName = this.ProjectSaleList[0].ProjectSaleCategoryName;
          this.ProjectSaleTool = this.ProjectSaleList[0].ProjectSaleTool;
          this.ProjectSalePhaseDisplay = this.ProjectSaleList[0].ProjectSalePhaseDisplay;
          this.ProjectSaleBudget = this.ProjectSaleList[0].ProjectSaleBudget;
          this.ProjectSaleYear = this.ProjectSaleList[0].ProjectSaleYear;

          this.ProjectSaleCloseDealProgress = this.ProjectSaleList[0].ProjectSaleCloseDealProgress;
          this.ProjectSaleName = this.ProjectSaleList[0].ProjectSaleName;
          //this.ProjectSaleContactPerson = this.ProjectSaleList[0].ProjectSaleContactPersonDisplay;
          this.ProjectSaleContactPerson = this.ProjectSaleList[0].ProjectSaleContactPerson;
          this.ProjectSaleContactPosition = this.ProjectSaleList[0].ProjectSaleContactPosition;
          this.ProjectSaleContactPersonPosition = this.ProjectSaleList[0].ProjectSaleContactPersonPosition;
          this.ProjectSaleCompanyDisplay = this.ProjectSaleList[0].ProjectSaleCompanyDisplay;
          this.ProjectSaleCompanyCode = this.ProjectSaleList[0].ProjectSaleCompanyCode;
          this.ProjectSaleCompanyDeliveryAddress = this.ProjectSaleList[0].ProjectSaleCompanyDeliveryAddress != null && this.ProjectSaleList[0].ProjectSaleCompanyDeliveryAddress != '' ? this.ProjectSaleList[0].ProjectSaleCompanyDeliveryAddress : '-';
          this.ProjectSaleCompanyTaxInvoiceAddress = this.ProjectSaleList[0].ProjectSaleCompanyTaxInvoiceAddress != null && this.ProjectSaleList[0].ProjectSaleCompanyTaxInvoiceAddress != '' ? this.ProjectSaleList[0].ProjectSaleCompanyTaxInvoiceAddress : '-';
          this.ProjectSaleCompanyDeliveryAddressdefault = this.ProjectSaleCompanyDeliveryAddress;
          this.ProjectSaleCompanyTaxInvoiceAddressdefault = this.ProjectSaleCompanyTaxInvoiceAddress;

          this.ProjectSaleDisplayAssignTo = this.ProjectSaleList[0].ProjectSaleAssignToDisaply;
          this.ProjectSaleAssignTo = this.ProjectSaleList[0].ProjectSaleAssignTo;

          this.ProjectSaleDisplayCreateBy = this.ProjectSaleList[0].ProjectSaleDisplayCreateBy;
          this.ProjectSaleCreateBy = this.ProjectSaleList[0].ProjectSaleCreateBy;
          this.ProjectSaleSubState = this.ProjectSaleList[0].ProjectSaleSubState;
          this.ProjectSaleCode = this.ProjectSaleList[0].ProjectSaleCode;
          this.ProjectSaleRemark = this.ProjectSaleList[0].ProjectSaleRemark;
          this.ProjectSaleContactTel = this.ProjectSaleList[0].ProjectSaleContactTel;
          this.ProjectSaleContactEmail = this.ProjectSaleList[0].ProjectSaleContactEmail;
          this.ProjectSaleContactDate = this.ProjectSaleList[0].ProjectSaleContactDate;
          this.ProjectSaleDeliveryAddress = this.ProjectSaleList[0].ProjectSaleDeliveryAddress != null && this.ProjectSaleList[0].ProjectSaleDeliveryAddress != '' ? this.ProjectSaleList[0].ProjectSaleDeliveryAddress : '-';
          this.ProjectSaleTaxInvoiceAddress = this.ProjectSaleList[0].ProjectSaleTaxInvoiceAddress != null && this.ProjectSaleList[0].ProjectSaleTaxInvoiceAddress != '' ? this.ProjectSaleList[0].ProjectSaleTaxInvoiceAddress : '-';

          this.ProjectSaleTeamCode = this.ProjectSaleList[0].ProjectSaleTeamCode;
          this.ProjectSaleTeamCodeDisplay = this.ProjectSaleList[0].ProjectSaleTeamCodeDisplay;

          this.ProjectSaleCloseDealComment = this.ProjectSaleList[0].ProjectSaleCloseDealComment;

          this.AssignLeadForm.patchValue({
            ddlAssignLead: this.ProjectSaleList[0].ProjectSaleAssignTo,
          });

          var objectSupportTeamFromJson = [];
          if (this.ProjectSaleList[0].ProjectSaleSupportTeam != null && this.ProjectSaleList[0].ProjectSaleSupportTeam != '') {
            objectSupportTeamFromJson = JSON.parse(this.ProjectSaleList[0].ProjectSaleSupportTeam);
          }

          for (let i = 0; i < objectSupportTeamFromJson.length; i++) {
            this.ProjectSaleSupportTeam += objectSupportTeamFromJson[i].SupporTeamName + ' , ';
          }

          // cut last 3 chaleater
          this.ProjectSaleSupportTeam = this.ProjectSaleSupportTeam.substring(0, this.ProjectSaleSupportTeam.length - 3);

          // get value Price & Time Zone
          this.InformationForm.get('PriceTimeForm').patchValue({
            ProjectSaleEstimatePrice: this.ProjectSaleList[0].ProjectSaleEstimatePrice != null ? this.ProjectSaleList[0].ProjectSaleEstimatePrice : 0,
            ProjectSaleActualPrice: this.ProjectSaleList[0].ProjectSaleActualPrice != null ? this.ProjectSaleList[0].ProjectSaleActualPrice : 0,
            ProjectSaleEstimateTime: this.ProjectSaleList[0].ProjectSaleEstimateTime != null ? this.ProjectSaleList[0].ProjectSaleEstimateTime : 0,
            PorjectSaleCommission: this.ProjectSaleList[0].PorjectSaleCommission != null ? parseInt(this.ProjectSaleList[0].PorjectSaleCommission) : 0,
            ProjectStartDealDate: this.ProjectSaleList[0].ProjectStartDealDate != null ? this.GlobalService.formatDate(this.ProjectSaleList[0].ProjectStartDealDate) : null,
            ProjectEndDealDate: this.ProjectSaleList[0].ProjectEndDealDate != null ? this.GlobalService.formatDate(this.ProjectSaleList[0].ProjectEndDealDate) : null,
          });
          this.GetCommissionActualPrice();

          // get request type for check disabled all control
          this.hideProjectSaleRequestType = this.ProjectSaleList[0].ProjectSaleRequestTypeCode;

          this.checkprocessClosedDealWarning();

          // set ProjectSaleExpectedClosePeriodMonth , ProjectSaleExpectedClosePerioddYear from database
          this.InformationForm.get('UpdateForm').patchValue({
            ProjectSaleExpectedClosePeriodMonth: this.ProjectSaleList[0].ProjectSaleClosedPeriodMonth != null ? parseInt(this.ProjectSaleList[0].ProjectSaleClosedPeriodMonth) : null,
            ProjectSaleExpectedClosePerioddYear: this.ProjectSaleList[0].ProjectSaleClosedPeriodYear != null ? parseInt(this.ProjectSaleList[0].ProjectSaleClosedPeriodYear) : null,
          });

          // get flag display for BD assign and State Approve Lead Only
          //this.IsShowForThisBDOnlyANDStateApproveLead = (this.ProjectSaleList[0].ProjectAssignBD == this.checkUndefinedString(localStorage.getItem("EmpCode")) && this.ProjectSaleList[0].ProjectSaleState == '1-3');
          this.IsShowForThisBDOnlyANDStateApproveLead = (this.ProjectSaleList[0].ProjectAssignBD == this.checkUndefinedString(localStorage.getItem("EmpCode")));
        
          this.ResetvaluePriceTime();
        }

        this.isViewOnly = this.ProjectSaleCloseDealProgress === "4";

      });

    }
  }

  btnClick_onUpdateProjectSale() {
    this.router2.navigateByUrl('/projectsale-information;status=u;id=' + this._ParamProjectSaleID + '');
  }

  btnClick_ViewProjectSale() {
    this.router2.navigateByUrl('/projectsale-information;status=v;id=' + this._ParamProjectSaleID + '');

  }

  // Call Rest api for change progress status
  async SubmitChangeProgressStatus() {
    if (this.InformationForm.get('CloseDealForm').valid && this.CloseDealSubState != '') {
      $('#confirmselectedstatus').modal('hide');
      $('#confirmclosedeal').modal('hide');

      this.loading(true, 'Saving ...');

      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };

        var objectjson = {};
        objectjson['ProjectSaleId'] = this._ParamProjectSaleID;
        objectjson['ProjectSaleCode'] = this.ProjectSaleCode;
        objectjson['ProjectSaleState'] = '1-5'; // Request for close deal
        objectjson['ProjectSaleSubState'] = this.CloseDealSubState;
        objectjson['ProjectSaleCloseDealProgress'] = '4'; // close deal
        objectjson['ProjectSaleEffortGroupId'] = this.InformationForm.get('CloseDealForm').get('EffortGroup').value; // close deal
        objectjson['ProjectSaleUpdateBy'] = this.GlobalService.checkUndefinedString(localStorage.getItem("EmpCode"));
        objectjson['ProjectSaleTeamCode'] = this.ProjectSaleTeamCode;
        objectjson['ProjectSaleCloseDealComment'] = this.InformationForm.get('CloseDealForm').get('Comment')?.value;

        let strjson = JSON.stringify(objectjson);

        this.isSubmitted = this.httpClient.post<ProjectSaleInfo[]>(this.baseurl + "ProjectSale/UpdateProjectSale", strjson, httpOptions)

          .subscribe(result => this.isSubmitted = result, failCb => {
            console.log("Update fail");
            this.loading(false);

            this.titlemodal = 'Submit Closed Deal Request fail.';
            this.detailmodal = 'Your information was submit fail.';



            $('#ModalError').modal();

          },
            () => {
              console.log("Update = " + this.isSubmitted);
              this.loading(false);
              this.titlemodal = 'Submit Closed Deal Request success.';
              this.detailmodal = 'Your Closed Deal Request has been submited.';

              $('#ModalComplate').modal();

              // when select close deal
              if (this.confirmselectedstatuscode == '4') {
                // update request type
                this.hideProjectSaleRequestType = '2';
              } else {
                // update progress
                this.ProjectSaleCloseDealProgress = this.confirmselectedstatuscode;

              }
              setTimeout(() => {
                // Do something after 2 seconds
                this.router2.navigateByUrl('/projectsale-management');
              }, 2000);


            }

          )

      }
    } else {
      if (this.CloseDealSubState == '') {
        this.CloseDealWarning = 'Please select closing type before action submit close deal.'
      }
      this.GlobalService.validateAllFormFields(this.InformationForm.get('CloseDealForm') as FormGroup);
    }


  }

  // Call Rest api for change Price & time Zone
  async SubmitChangePriceTimeZone() {
    if (this.InformationForm.get('PriceTimeForm').valid) {
      this.loading(true, 'Saving ...');
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };

        var objectjson = {};
        objectjson['ProjectSaleId'] = this._ParamProjectSaleID;
        objectjson['ProjectSaleEstimatePrice'] = this.InformationForm.get('PriceTimeForm').get('ProjectSaleEstimatePrice').value;
        objectjson['ProjectSaleActualPrice'] = this.InformationForm.get('PriceTimeForm').get('ProjectSaleActualPrice').value;
        objectjson['ProjectSaleActualPriceRef'] = this.InformationForm.get('PriceTimeForm').get('ProjectSaleActualPrice').value;
        objectjson['ProjectSaleEstimateTime'] = this.InformationForm.get('PriceTimeForm').get('ProjectSaleEstimateTime').value;
        objectjson['PorjectSaleCommission'] = this.InformationForm.get('PriceTimeForm').get('PorjectSaleCommission').value.toString();
        objectjson['ProjectStartDealDate'] = this.InformationForm.get('PriceTimeForm').get('ProjectStartDealDate').value;
        objectjson['ProjectEndDealDate'] = this.InformationForm.get('PriceTimeForm').get('ProjectEndDealDate').value;
        objectjson['ProjectSaleTeamCode'] = this.ProjectSaleTeamCode;
        objectjson['ProjectSaleUpdateBy'] = this.GlobalService.checkUndefinedString(localStorage.getItem("EmpCode"));

        let strjson = JSON.stringify(objectjson);

        this.isSubmitted = this.httpClient.post<ProjectSaleInfo[]>(this.baseurl + "ProjectSale/UpdateProjectSale", strjson, httpOptions)

          .subscribe(result => this.isSubmitted = result, failCb => {
            console.log("Update fail");
            this.loading(false);

            this.titlemodal = 'Save detail price & time fail.';
            this.detailmodal = 'Your information was save fail.';



            $('#ModalError').modal();

          },
            () => {
              console.log("Update = " + this.isSubmitted);
              this.loading(false);
              this.titlemodal = 'Save detail price & time success.';
              this.detailmodal = 'your detail price & time has been saved.';

              $('#ModalComplate').modal();
              // load information
              this.LoadInformationFromId();
              
            }

          )
      }
    } else {
      this.GlobalService.markFormGroupTouched(this.InformationForm.get('PriceTimeForm') as FormGroup);

    }

  }

  // Call Rest api for insert project sale attach file after uploaded
  async InsertProjectSaleAttachFile(Filename, pathfile, traget) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['ProjectSaleId'] = this._ParamProjectSaleID;
      objectjson['ProjectSaleAttachmentFileName'] = Filename;
      objectjson['ProjectSaleAttachmentPathFile'] = pathfile;
      objectjson['CreateBy'] = localStorage.getItem("EmpCode");



      let strjson = JSON.stringify(objectjson);

      this.isSubmitted = this.httpClient.post<ProjectSaleAttachmentInfo[]>(this.baseurl + "ProjectSaleAttachment/InsertProjectSaleAttachment", strjson, httpOptions)

        .subscribe(result => this.isSubmitted = result, failCb => {
          console.log("Insert fail")
        },
          () => {
            console.log("Insert = " + this.isSubmitted);

            //save attach id to traget file
            var indextraget = this.ProjectSaleAttachmentList.findIndex(x => x.traget === parseInt(traget));
            if (indextraget != -1) {
              this.ProjectSaleAttachmentList[indextraget].ProjectSaleAttachmentId = this.isSubmitted;
            }

          }
        )
    }
  }



  // Call Rest api for insert Activity Log & Note
  async InsertProjectSaleActivityLogNote() {
    this.loading(true, 'Submiting ...');
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['ProjectSaleId'] = this._ParamProjectSaleID;
      objectjson['ActivityLogNote'] = this.ProjectSaleActivityNote;
      objectjson['CreateBy'] = localStorage.getItem("EmpCode");



      let strjson = JSON.stringify(objectjson);

      this.isSubmitted = this.httpClient.post<ProjectSaleAttachmentInfo[]>(this.baseurl + "ProjectSaleActivityLogNote/InsertProjectSaleActivityLogNote", strjson, httpOptions)

        .subscribe(result => this.isSubmitted = result, failCb => {
          console.log("Insert fail");
          this.loading(false);

          this.titlemodal = 'Submit note fail.';
          this.detailmodal = 'Your information was submit fail.';



          $('#ModalError').modal();
        },
          () => {
            console.log("Insert = " + this.isSubmitted);
            this.loading(false);
            this.titlemodal = 'Submit note status success.';
            this.detailmodal = 'your note status has been saved.';

            $('#ModalComplate').modal();
            //clear input note
            this.ProjectSaleActivityNote = '';
            // reload note
            this.currentPageNumber = 1;

            this.OnLoadProjectSaleActivityLogNoteList();

            this.OnLoadCountProjectSaleActivityLogNoteList();

          }
        )
    }
  }
  async DeleteProjectSaleActivityLogNote(id) {

    if (confirm("Do you want yo delete activity note ?")) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };

        var objectjson = {};
        objectjson['ProjectSaleActivityLogNoteId'] = id;
        objectjson['UpdateBy'] = localStorage.getItem("EmpCode");

        let strjson = JSON.stringify(objectjson);

        this.isSubmitted = this.httpClient.post<ProjectSaleAttachmentInfo[]>(this.baseurl + "ProjectSaleActivityLogNote/DeleteProjectSaleActivityLogNote", strjson, httpOptions)

          .subscribe(result => this.isSubmitted = result, failCb => {
            console.log("Delete fail");
            this.loading(false);

            this.titlemodal = 'Submit delete note fail.';
            this.detailmodal = 'Your information was submit fail.';

            $('#ModalError').modal();
          },
            () => {
              console.log("Insert = " + this.isSubmitted);
              this.loading(false);
              this.titlemodal = 'Delete note activity success.';
              this.detailmodal = 'your note activity has been deleted.';

              $('#ModalComplate').modal();
              //clear input note
              this.ProjectSaleActivityNote = '';
              // reload note
              this.currentPageNumber = 1;

              this.OnLoadProjectSaleActivityLogNoteList();

              this.OnLoadCountProjectSaleActivityLogNoteList();

            }
          )
      }
    }
  }

  // Call Rest api for change address
  async SubmitChangeAddress() {
    $('#modaladd_addrees').modal('hide');
    this.loading(true, 'Saving ...');
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['ProjectSaleId'] = this._ParamProjectSaleID;
      objectjson['ProjectSaleDeliveryAddress'] = this.ProjectSaleCompanyDeliveryAddress;
      objectjson['ProjectSaleTaxInvoiceAddress'] = this.ProjectSaleCompanyTaxInvoiceAddress;
      objectjson['ProjectSaleTeamCode'] = this.ProjectSaleTeamCode;
      objectjson['ProjectSaleUpdateBy'] = this.GlobalService.checkUndefinedString(localStorage.getItem("EmpCode"));

      let strjson = JSON.stringify(objectjson);

      this.isSubmitted = this.httpClient.post<ProjectSaleInfo[]>(this.baseurl + "ProjectSale/UpdateProjectSale", strjson, httpOptions)

        .subscribe(result => this.isSubmitted = result, failCb => {
          console.log("Save fail");
          this.loading(false);

          this.titlemodal = 'Save address fail.';
          this.detailmodal = 'Your information was save fail.';



          $('#ModalError').modal();

        },
          () => {
            console.log("Save = " + this.isSubmitted);
            this.loading(false);
            this.titlemodal = 'Save address success.';
            this.detailmodal = 'your address has been saved.';

            $('#ModalComplate').modal();

            // update information
            this.ProjectSaleDeliveryAddress = this.ProjectSaleCompanyDeliveryAddress;
            this.ProjectSaleTaxInvoiceAddress = this.ProjectSaleCompanyTaxInvoiceAddress;

          }

        )
    }
  }

  async btnClick_deleteProjectSaleAttachFile() {
    $('#confirmremoveattachfile').modal('hide');
    this.loading(true, 'Removing ...');
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
      var objectjson = {};
      objectjson['ProjectSaleAttachmentId'] = this.confirmselectedAttachFileId;

      let strjson = JSON.stringify(objectjson);



      this.isSubmitted = this.httpClient.post<ProjectSaleAttachmentInfo[]>(this.baseurl + "ProjectSaleAttachment/DeleteProjectSaleAttachment", strjson, httpOptions)

        .subscribe(result => this.isSubmitted = result, failCb => {
          console.log("remove fail");
          this.loading(false);

          this.titlemodal = 'Remove attach file fail.';
          this.detailmodal = 'Your selected attach file was remove fail.';



          $('#ModalError').modal();
        },
          () => {
            console.log("remove = " + this.isSubmitted);

            this.loading(false);
            this.titlemodal = 'Remove attach file success.';
            this.detailmodal = 'Your attach file has been removed.';

            $('#ModalComplate').modal();

            // remove from list
            this.ProjectSaleAttachmentList = this.ProjectSaleAttachmentList.filter(item => item.ProjectSaleAttachmentId !== this.confirmselectedAttachFileId)

          }
        )
    }
  }

  // when upload Finished
  uploadFinished(traget) {
    this.InsertProjectSaleAttachFile(traget.list[0].fileName, traget.list[0].dbPath, traget.list[0].traget);
  }


  mouseentertimeline(traget) {
    var indextraget = $(traget.currentTarget).parent().parent().parent().index();
    var ullist = $(traget.currentTarget).parent().parent().parent().parent();
    $(ullist.find('li')).each((i, obj) => {
      if (indextraget >= i) {
        $(obj).addClass('complete');
      } else {
        return;
      }
    });
  }

  mouseleavetimeline(traget) {
    var indextraget = $(traget.currentTarget).parent().parent().parent().index();
    var ullist = $(traget.currentTarget).parent().parent().parent().parent();
    $(ullist.find('li')).each((i, obj) => {
      if (indextraget >= i) {
        $(obj).removeClass('complete');
      } else {
        return;
      }
    });
  }

  async ConfirmChangeStatus(statusdisaply, statuscode) {

    debugger
    if (this.checkprocessClosedDealRequest() != true) {
      this.confirmselectedstatus = statusdisaply;
      this.confirmselectedstatuscode = statuscode;

      // if stauts selected eq Closed deal
      if (this.confirmselectedstatuscode == '4') {
        // require Est. Price , Actual Price , Est. Time , Commission , Start deal date , End deal date
        var ProjectSaleEstimatePrice = this.InformationForm.get('PriceTimeForm').get('ProjectSaleEstimatePrice');
        var ProjectSaleActualPrice = this.InformationForm.get('PriceTimeForm').get('ProjectSaleActualPrice');
        var ProjectSaleEstimateTime = this.InformationForm.get('PriceTimeForm').get('ProjectSaleEstimateTime');
        var PorjectSaleCommission = this.InformationForm.get('PriceTimeForm').get('PorjectSaleCommission');
        var ProjectStartDealDate = this.InformationForm.get('PriceTimeForm').get('ProjectStartDealDate');
        var ProjectEndDealDate = this.InformationForm.get('PriceTimeForm').get('ProjectEndDealDate');

        await this.CheckPipelineStatusBeforeCloseDeal(this.ProjectSaleCode);

        if ((ProjectSaleEstimatePrice.value == 0 || ProjectSaleEstimatePrice.value == null) ||
          (ProjectSaleActualPrice.value == 0 || ProjectSaleActualPrice.value == null) ||
          // (ProjectSaleEstimateTime.value == 0 || ProjectSaleEstimateTime.value == null) ||
          // (PorjectSaleCommission.value == 0 || PorjectSaleCommission.value == null) ||
          (ProjectStartDealDate.value == '' || ProjectStartDealDate.value == null) ||
          (ProjectEndDealDate.value == '' || ProjectEndDealDate.value == null)
        ) {
          // modal popup
          this.titlemodal = 'Warning!';
          this.detailmodal = 'You cannot close deal request because you haven\'t filled out the Price & Time information not yet complete, Please complete it and try again.';

          $('#ModalComplate').modal();
          return;
        } else {
            if (!this.ProjectPipeLineQuoStatusList || this.ProjectPipeLineQuoStatusList.length === 0) {
              this.titlemodal = 'Warning!';
              this.detailmodal = 'Please update ProjectSale Pipeline Status to quotation';
              $('#ModalComplate').modal();
                return;
            }
          
          $('#confirmclosedeal').modal();
          return;
        }
      }

      if (statuscode != this.ProjectSaleCloseDealProgress) {
        $('#confirmselectedstatus').modal();
      }
    } else {
      this.checkprocessClosedDealWarning();

    }

  }

  ConfirmRemoveAttachFile(AttachFilename, ProjectSaleAttachmentId) {
    this.confirmselectedAttachFileName = AttachFilename;
    this.confirmselectedAttachFileId = ProjectSaleAttachmentId;
    $('#confirmremoveattachfile').modal();
  }

  ModalAddAddress() {
    // set default radio
    $('input:radio[name=RadioAddress][value=S]').click();
    $('#chksamedeliveryaddress').prop('checked', false); // Unchecks Same delivery address

    $('#modaladd_addrees').modal();
  }

  OnRadioAddressChange(traget) {
    // N = New adddress , S = Same address
    var selectedRadio = traget.currentTarget.value;
    $('#chksamedeliveryaddress').prop('checked', false); // Unchecks Same delivery address

    if (selectedRadio == 'S') {
      this.FlagDisabledAddress = true;
      this.ProjectSaleCompanyDeliveryAddress = this.ProjectSaleCompanyDeliveryAddressdefault;
      this.ProjectSaleCompanyTaxInvoiceAddress = this.ProjectSaleCompanyTaxInvoiceAddressdefault;

    } else if (selectedRadio == 'N') {
      this.FlagDisabledAddress = null;
      this.ProjectSaleCompanyDeliveryAddress = '-';
      this.ProjectSaleCompanyTaxInvoiceAddress = '-';
    }
  }

  OnCheckBoxSameDeliveryAddress(traget) {
    var checked = $(traget.currentTarget).prop('checked');
    var selectedRadio = $('input[name="RadioAddress"]:checked').val();


    // if checked
    if (checked == true) {
      this.ProjectSaleCompanyTaxInvoiceAddress = this.ProjectSaleCompanyDeliveryAddress;


    } else {
      if (selectedRadio == 'S') {
        this.ProjectSaleCompanyTaxInvoiceAddress = this.ProjectSaleCompanyTaxInvoiceAddressdefault;

      } else if (selectedRadio == 'N') {
        this.ProjectSaleCompanyTaxInvoiceAddress = '-';
      }
    }

  }

  async selectedTabChange(traget) {

    if (traget.tab.textLabel == 'Activity log & note') {

    } else if (traget.tab.textLabel == 'Price & Time') {
      this.InformationForm.get('PriceTimeForm').markAsUntouched();
      this.ResetvaluePriceTime();
    } else if (traget.tab.textLabel == 'Assign Member') {
      await this.ReLoadAssignMember();

    }


  }

  // Function about loading
  loading(flag: boolean, Msg: string = '') {
    this.displayloading = flag;
    this.Msgloadding = Msg;
  }

  // Function convert byte to size file
  formatBytes(byte) {
    return this.GlobalService.formatBytes(byte);
  }

  //Function upload file on change
  public uploadFile = async (files) => {

    if (files.length === 0) {
      return;
    }

    var auth_token = await this.TokenService.RefreshToken();

    if (!!auth_token) {

      const httpOptions = {

      };



      let filesToUpload: File[] = files;

      Array.from(filesToUpload).map((file, index) => {
        // push uoload list
        this.AdduploadingList(file.name);
        const formData = new FormData();
        formData.append("pathfile", "Resources\\ProjectSale");
        formData.append("traget", this.itragetuploadstart.toString());
        formData.append('file' + index, file, file.name);

        // check upload count
        let check = this.ProjectSaleAttachmentList.filter(function (item) {
          return item.progress != 100;
        });

        this.httpClient.post(this.baseurl + "api/upload", formData, {
          reportProgress: true, observe: 'events', headers: new HttpHeaders({
            'Authorization': `Bearer ${auth_token}`
          })
        })
          .subscribe(event => {
            if (event.type === HttpEventType.UploadProgress) {
              var progress = Math.round(100 * event.loaded / event.total);



              // check current file is set size
              let check = this.ProjectSaleAttachmentList.filter(function (item) {
                return item.SizeFile == event.total;
              });

              // is not set
              if (check.length == 0) {
                // update size list
                this.Updateuploadingsizelist(Number(event.total));
              }

              if (progress >= 1) {
                // update progress
                this.Updateuploadingprogresslist(Number(event.total), progress);
              }


              if (progress == 100) {
                // check upload count
                let check = this.ProjectSaleAttachmentList.filter(function (item) {
                  return item.progress != 100;
                });

              }

            } else if (event.type === HttpEventType.Response) {
              this.uploadFinished(event.body);

            }
          });


      });
    }



  }


  public AdduploadingList(filename: string) {
    this.itragetuploadstart = this.itragetuploadstart + 1;
    var projectattachfile = new ProjectSaleAttachmentInfo;
    projectattachfile.ProjectSaleAttachmentFileName = filename;
    projectattachfile.SizeFile = 0;
    projectattachfile.traget = this.itragetuploadstart;
    projectattachfile.progress = 0;

    this.ProjectSaleAttachmentList.unshift(projectattachfile);

  }

  public Updateuploadingsizelist(sizefile: number) {
    this.itragetuploadprogress = this.itragetuploadprogress + 1;

    let itemIndex = this.ProjectSaleAttachmentList.findIndex(item => item.traget == this.itragetuploadprogress && item.SizeFile == 0);
    if (itemIndex != -1) {
      this.ProjectSaleAttachmentList[itemIndex].SizeFile = sizefile;

    }
  }


  public Updateuploadingprogresslist(sizefile: number, progress: number) {

    let itemIndex = this.ProjectSaleAttachmentList.findIndex(item => item.SizeFile == sizefile);
    if (itemIndex != -1) {
      this.ProjectSaleAttachmentList[itemIndex].progress = progress;

    }
  }

  DowloadProjectSaleAttachFile(ProjectSaleAttachmentId) {
    if (ProjectSaleAttachmentId != 0 && ProjectSaleAttachmentId != null) {
      window.open(this.baseurl + 'ProjectSaleAttachment/downloadfile/' + ProjectSaleAttachmentId + '?access_token=' + this.access_token + '', '_blank');

    }
  }

  GetTypeFile(filename) {
    var retruntypefile = '';
    var indexfind = -1;
    var extensionfile = this.GlobalService.getExtension(filename);
    var onlyone = ['css', 'csv', 'html', 'js', 'json', 'pdf', 'png', 'txt', 'xml', 'zip', 'rar', 'mp3', 'mp4'];
    var word = ['doc', 'docm', 'docx', 'dot', 'dotx'];
    var jpg = ['jpg', 'jpeg'];
    var powerpoint = ['pptx', 'pptm', 'ppt', 'ppsx', 'ppsm', 'pps', 'ppam', 'potx', 'potm', 'pot'];
    var Excel = ['xltx', 'xltm', 'xlt', 'xlsx', 'xlsm', 'xls', 'xlm', 'xll', 'xlam', 'xla'];

    // find from array onlyone
    indexfind = onlyone.findIndex(item => item == extensionfile);

    // not found
    if (indexfind == -1) {
      // check from array word
      indexfind = word.findIndex(item => item == extensionfile);
      if (indexfind != -1) {
        retruntypefile = 'word';
      } else {
        // check from array jpg
        indexfind = jpg.findIndex(item => item == extensionfile);

        if (indexfind != -1) {
          retruntypefile = 'jpg';
        } else {
          // check from array powerpoint
          indexfind = powerpoint.findIndex(item => item == extensionfile);

          if (indexfind != -1) {
            retruntypefile = 'ppt';
          } else {
            // check from array Excel
            indexfind = Excel.findIndex(item => item == extensionfile);

            if (indexfind != -1) {
              retruntypefile = 'xls';
            } else {
              retruntypefile = 'default';
            }

          }

        }
      }

    } else {
      // found item
      retruntypefile = extensionfile;
    }

    return retruntypefile;
  }

  // Function Update variable abount pagination
  LoadProjectSaleActivityLogNoteUpdatePagination(traget) {
    this.currentPageNumber = traget.currentPageNumber;
    this.totalPages = traget.totalPages;
    this.indexNo = traget.index;

  }

  // validate start date end date
  checkdate(
    controlName: string,
    matchingControlName: string
  ) {
    return (formGroup: FormGroup) => {
      const startcontrol = formGroup.controls[controlName];
      const endcontrol = formGroup.controls[matchingControlName];

      if (endcontrol.errors && !endcontrol.errors.checkdate) {
        return;
      }

      if (Date.parse(startcontrol.value) > Date.parse(endcontrol.value)) {
        endcontrol.setErrors({ checkdate: true });
      } else {
        endcontrol.setErrors(null);
      }
    };
  }


  GetCommissionActualPrice() {
    var ActualPrice = this.InformationForm.get('PriceTimeForm').get('ProjectSaleActualPrice');
    var Commissionpercentage = this.InformationForm.get('PriceTimeForm').get('PorjectSaleCommission');
    var PriceofCommission = this.InformationForm.get('PriceTimeForm').get('Commissiontotal');

    var value = Number(this.numberRemoveCommas(ActualPrice.value)) * (Commissionpercentage.value / 100)
    PriceofCommission.setValue(this.numberWithCommas(value));
  }

  GetCommissionActualPricepercentage() {
    var ActualPrice = this.InformationForm.get('PriceTimeForm').get('ProjectSaleActualPrice');
    var Commissionpercent = this.InformationForm.get('PriceTimeForm').get('PorjectSaleCommission');
    var PriceofCommission = this.InformationForm.get('PriceTimeForm').get('Commissiontotal');

    Commissionpercent.setValue(PriceofCommission.value / ActualPrice.value * 100);
  }

  numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  numberRemoveCommas(x) {
    return x.toString().replace(/,/g, '');
  }

  checkprocessClosedDealRequest() {
    //debugger
    var flagdisable = null;
    // if ProjectSaleCloseDealProgress is Closed deal mean all done don't update any more
    // if hideProjectSaleRequestType eq Close deal  meam request in progress
    if (this.ProjectSaleCloseDealProgress == "4" || this.hideProjectSaleRequestType == "2") {
      flagdisable = true;
    }

    return flagdisable;
  }

  checkprocessClosedDealWarning() {
    // if close deal request in progress
    if (this.isViewOnly == false) {
      if (this.hideProjectSaleRequestType == '2' && this.ProjectSaleCloseDealProgress != '4') {
        // modal popup
        this.titlemodal = 'Warning!';
        this.detailmodal = 'This Project Lead cannot currently be updated because a close deal request is in progress, Please complete it and try again.';
        $('#ModalComplate').modal();

      } 
      // else// if close deal approved
      //   if (this.ProjectSaleCloseDealProgress == '4') {
      //     // modal popup
      //     this.titlemodal = 'Warning!';
      //     this.detailmodal = 'This Project Lead cannot currently be updated because a closed deal.';
      //     $('#ModalComplate').modal();

      //   }
    }



  }

  // Get ProjectSale Budget && Function
  async LoadProjectSaleBudget() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {

      this.LoadProjectSaleBudgetList(auth_token)

        .subscribe({
          next: data => {
            this.ProjectSaleBudgetList = data;
            this.hidcouchk = this.ProjectSaleBudgetList.length.toString();
          },
          error: error => {
            console.error('There was an error!', error);
          }
        });
    }
  }

  LoadProjectSaleBudgetList(auth_token): Observable<ProjectSaleBudgetInfo[]> {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    let offset = (this.currentPageProjectSaleBudgetNumber - 1) * environment.PageSize;

    var objectjson = {};
    objectjson['ProjectSaleID'] = this._ParamProjectSaleID;
    objectjson['FlagDelete'] = "N";
    objectjson['rowFetch'] = environment.PageSize;
    objectjson['rowOFFSet'] = offset;


    let strjson = JSON.stringify(objectjson);

    return this.httpClient
      .post<ProjectSaleBudgetInfo[]>(this.baseurl + "ProjectSaleBudget/GetProjectSaleBudget",
        strjson, httpOptions)

  }

  async LoadCountProjectSaleBudgetList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['ProjectSaleID'] = this._ParamProjectSaleID;
      objectjson['FlagDelete'] = "N";

      let strjson = JSON.stringify(objectjson);
      this.httpClient.post<number>(this.baseurl + "ProjectSaleBudget/GetCountGetProjectSaleBudget", strjson, httpOptions)
        .toPromise()
        .then(data => {
          this.ProjectSaleBudgetTotal = data;
          this.totalProjectSaleBudgetPages = Math.ceil(this.ProjectSaleBudgetTotal / environment.PageSize);
          if (data == 0) {
            this.currentPageProjectSaleBudgetNumber = 1;
          }
        })
    }
  }

  OnLoadCountProjectSaleBudgetList() {
    //call function load count all ticket list on hand current role user
    this.LoadCountProjectSaleBudgetList()
  }

  async OnLoadProjectSaleBudgetList(traget = null) {

    if (traget != null) { // check call function from change page or onloadfrist
      this.LoadProjectSaleBudgetUpdatePagination(traget);
    }

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      this.LoadProjectSaleBudgetList(auth_token).subscribe(data => { //call function load ticket list on hand current role user
        this.ProjectSaleBudgetList = data;
      })
    }
  }

  LoadProjectSaleBudgetUpdatePagination(traget) {
    this.currentPageProjectSaleBudgetNumber = traget.currentPageNumber;
    this.totalProjectSaleBudgetPages = traget.totalPages;
  }

  chkallProjectSaleBudgetclick(traget) {
    var check = $(traget.currentTarget).is(":checked");

    $('[name="checkboxProjectSaleBudget"]').prop('checked', check);

  }

  btnClick_onCreateProjectSaleBudget() {
    this.IsClearList = "false";
    $('#ModalProjectSaleBudget').modal('show');
    this.txtProjectSaleBudgetGLName = "";
    this.txtProjectSaleBudgetAmount = 0;
    this.ProjectSaleBudgetAttachedFileList = [];

    this.validatetxtProjectSaleBudgetGLName = 'False';
    this.validatetxtProjectSaleBudgetAmount = 'False';

    this.isOnUpdate = false;
  }

  displayFieldCss(field: string) {
    return {
      'has-error': this.isFieldValid(field),
      'has-feedback': this.isFieldValid(field)
    };
  }

  displayFieldCssCloseDeal(field: string) {
    return {
      'has-error': this.isFieldValidCloseDeal(field),
      'has-feedback': this.isFieldValidCloseDeal(field)
    };
  }

  async loadLookup(lookuptype: string) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['LookupType'] = this.checkUndefinedString(lookuptype);

      let strjson = JSON.stringify(objectjson);

      return await this.httpClient.post<LookupInfo[]>(this.baseurl + "Lookup/GetLookup", strjson, httpOptions)
        .toPromise()
    }
  }

  checkUndefinedString(strInput: string) {
    if (strInput === undefined || strInput === null) {
      strInput = ''
    }
    return strInput

  }

  isFieldValid(field: string) {
    return !this.InformationForm.get('UpdateForm').get(field).valid && this.InformationForm.get('UpdateForm').get(field).touched;
  }

  isFieldValidCloseDeal(field: string) {
    return !this.InformationForm.get('CloseDealForm').get(field).valid && this.InformationForm.get('CloseDealForm').get(field).touched;
  }

  DragFilesFinished(returnObj) {

    if (!!returnObj.Message) {
      alert(returnObj.Message)
    } else {
      this.projectsaleBudgetFilesToUpload = returnObj.Files;
      this.projectsaleBudgetPathFile = returnObj.PathFile;
    }
  }

  async btnClick_submitInsertProjectSaleBudget() {
    this.ValidateInsertProjectSaleBudget();

    if (this.validatetxtProjectSaleBudgetGLName == 'True' || this.validatetxtProjectSaleBudgetAmount == 'True') {
      return;
    }
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['ProjectSaleID'] = this._ParamProjectSaleID;
      objectjson['ProjectSaleBudgetGLCode'] = this.checkUndefinedString(this.txtProjectSaleBudgetGLName);
      objectjson['ProjectSaleBudgetAmount'] = this.txtProjectSaleBudgetAmount;
      objectjson['CreateBy'] = this.checkUndefinedString(localStorage.getItem("EmpCode"));
      objectjson['FlagDelete'] = "N";

      let strjson = JSON.stringify(objectjson);

      this.isSubmitted = this.httpClient.post<ProjectSaleBudgetInfo[]>(this.baseurl + "ProjectSaleBudget/InsertProjectSaleBudget", strjson, httpOptions)
        .subscribe(result => this.isSubmitted = result, failCb => {
          console.log("Insert fail")
        },
          async () => {
            console.log("Insert = " + this.isSubmitted)

            ////also insert to expense
            //this.expenseclaims_submitInsertProjectSaleBudget();

            this.OnCreating('n');

            if (!!this.projectsaleBudgetFilesToUpload && this.projectsaleBudgetFilesToUpload.length > 0) {
              var isUploadSuccess = await this.UploadProjectSaleBudgetAttachedFilesToServer(this.projectsaleBudgetFilesToUpload);
              if (isUploadSuccess) {
                for (const val of this.projectsaleBudgetFilesToUpload) {
                  await this.InsertProjectSaleBudgetAttachedFile(val.name, this.projectsaleBudgetPathFile + "\\" + val.name, this.isSubmitted)
                }
              }

              $('#ModalProjectSaleBudgetCreateComplete').modal();
              this.IsClearList = "true";
              this.projectsaleBudgetFilesToUpload = [];
              this.OnCreating('n');
              this.LoadProjectSaleBudget();
              this.LoadProjectSaleBudgetAttachedFile(this.isSubmitted);
              this.OnLoadCountProjectSaleBudgetList();
            }
            else {
              $('#ModalProjectSaleBudgetCreateComplete').modal();
              this.IsClearList = "false";
              this.projectsaleBudgetFilesToUpload = [];
              this.OnCreating('n');
              this.LoadProjectSaleBudget();
              this.LoadProjectSaleBudgetAttachedFile(this.isSubmitted);
              this.OnLoadCountProjectSaleBudgetList();
            }

          }
        )

    }
  }

  async expenseclaims_submitInsertProjectSaleBudget() {

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['ProjectSaleID'] = this._ParamProjectSaleID;
      objectjson['ProjectSaleBudgetGLCode'] = this.checkUndefinedString(this.txtProjectSaleBudgetGLName);
      objectjson['ProjectSaleBudgetAmount'] = this.txtProjectSaleBudgetAmount;
      objectjson['CreateBy'] = this.checkUndefinedString(localStorage.getItem("EmpCode"));
      objectjson['FlagDelete'] = "N";

      let strjson = JSON.stringify(objectjson);

      this.isSubmitted = this.httpClient.post<ProjectSaleBudgetInfo[]>(this.expense_baseurl + "ProjectSaleBudget/InsertProjectSaleBudget", strjson, httpOptions)
        .subscribe(result => this.isSubmitted = result, failCb => {
          console.log("Insert fail")
        },
          async () => {
            console.log("Insert to expense= " + this.isSubmitted)
          }
        )

    }
  }

  ValidateInsertProjectSaleBudget() {
    if ((this.txtProjectSaleBudgetGLName == "" || this.txtProjectSaleBudgetGLName == null)) {
      this.validatetxtProjectSaleBudgetGLName = 'True';
    } else {
      this.validatetxtProjectSaleBudgetGLName = 'False';
    }

    if (this.txtProjectSaleBudgetAmount.toString() == "" || this.txtProjectSaleBudgetAmount == null || this.txtProjectSaleBudgetAmount < 0) {
      this.validatetxtProjectSaleBudgetAmount = 'True';
    } else {
      this.validatetxtProjectSaleBudgetAmount = 'False';
    }
  }

  OnCreating(flag) {
    if (flag == 'y') {
    } else if (flag == 'n') {
      $('#ModalProjectSaleBudget').modal('hide');
      $('#ModalProjectSaleCost').modal('hide');
    }

  }

  async UploadProjectSaleBudgetAttachedFilesToServer(files) {

    if (!files || files.length === 0) {
      alert("Please browse file at least one.")
      return false;
    }
    let filesToUpload: File[] = files;

    await Array.from(filesToUpload).map((file, index) => {
      // push uoload list
      const formData = new FormData();
      formData.append("pathfile", this.projectsaleBudgetPathFile);
      formData.append('file' + index, file, file.name);
      this.httpClient.post(this.baseurl + "api/upload", formData, { reportProgress: true, observe: 'events' })
        .subscribe(event => {
          if (event.type === HttpEventType.UploadProgress) {
            var progress = Math.round(100 * event.loaded / event.total);

            if (progress == 100) {
            }

          } else if (event.type === HttpEventType.Response) {
          }
        });



    });

    return true;
  }

  async InsertProjectSaleBudgetAttachedFile(Filename, pathfile, projectsalebudgetid) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['ProjectSaleBudgetID'] = projectsalebudgetid;
      objectjson['ProjectSaleBudgetAttachedFileFileName'] = Filename;
      objectjson['ProjectSaleBudgetAttachedFilePathFile'] = pathfile;
      objectjson['FlagDelete'] = "N";
      objectjson['CreateBy'] = localStorage.getItem("EmpCode");




      let strjson = JSON.stringify(objectjson);

      this.isProjectSaleBudgetAttachedFileSubmitted = this.httpClient.post<ProjectSaleBudgetAttachedFileInfo[]>(this.baseurl + "ProjectSaleBudgetAttachedFile/InsertProjectSaleBudgetAttachedFile", strjson, httpOptions)

        .subscribe(result => this.isProjectSaleBudgetAttachedFileSubmitted = result, failCb => {
          console.log("Insert fail")
        },
          () => {
            console.log("Insert = " + this.isProjectSaleBudgetAttachedFileSubmitted)
          }
        )
    }
  }

  async LoadProjectSaleBudgetAttachedFile(projectsalebudgetid) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      this.LoadProjectSaleBudgetAttachedFileList(projectsalebudgetid, auth_token)
        .subscribe({
          next: data => {
            this.ProjectSaleBudgetAttachedFileList = data;
          },
          error: error => {
            console.error('There was an error!', error);
          }
        });
    }
  }

  LoadProjectSaleBudgetAttachedFileList(projectsalebudgetid, auth_token): Observable<ProjectSaleBudgetAttachedFileInfo[]> {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    var objectjson = {};


    objectjson['ProjectSaleBudgetID'] = projectsalebudgetid;
    objectjson['FlagDelete'] = "N";

    let strjson = JSON.stringify(objectjson);
    return this.httpClient
      .post<ProjectSaleBudgetAttachedFileInfo[]>(this.baseurl + "ProjectSaleBudgetAttachedFile/GetProjectSaleBudgetAttachedFile",
        strjson, httpOptions)

  }

  btnClick_onUpdateProjectSaleBudget(id) {
    this.validatetxtProjectSaleBudgetGLName = 'False';
    this.validatetxtProjectSaleBudgetAmount = 'False';

    this.isOnUpdate = true;
    this.IsClearList = "false";

    let index = this.ProjectSaleBudgetList.findIndex(x => x.ProjectSaleBudgetID == id);

    this.txtProjectSaleBudgetGLName = this.ProjectSaleBudgetList[index].ProjectSaleBudgetGLCode != null ? this.ProjectSaleBudgetList[index].ProjectSaleBudgetGLCode : null
    this.txtProjectSaleBudgetAmount = this.ProjectSaleBudgetList[index].ProjectSaleBudgetAmount != null ? this.ProjectSaleBudgetList[index].ProjectSaleBudgetAmount : null
    this.hidprojectsalebudgetId = this.ProjectSaleBudgetList[index].ProjectSaleBudgetID;

    this.LoadProjectSaleBudgetAttachedFile(id);

    $('#ModalProjectSaleBudget').modal();
  }

  async btnClick_onDeleteProjectSaleBudgetList() {

    if (confirm("Are you sure you want to delete this Company?")) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        var checkboxProjectSaleBudget = $('[name="checkboxProjectSaleBudget"]:checked');

        let num = checkboxProjectSaleBudget.length;
        let observableBatch = [];
        for (var i = 0; i < num; i++) {

          var ProjectSaleBudgetcurrent = <HTMLInputElement>checkboxProjectSaleBudget[i];
          observableBatch.push(this.btnClick_deleteProjectSaleBudget(parseInt(ProjectSaleBudgetcurrent.value), auth_token).toPromise().then(val => {
          }));

        }

        // ยังไม่ใช้งาน
        //also delete for expense
        //let observableBatch2 = [];
        //for (var i = 0; i < num; i++) {

        //  let ProjectSaleBudgetcurrent = <HTMLInputElement>checkboxProjectSaleBudget[i];
        //  observableBatch2.push(this.expenseclaims_deleteProjectSaleBudget(parseInt(ProjectSaleBudgetcurrent.value), auth_token).toPromise().then(val => {
        //  }));

        //}

        Promise.all(observableBatch).then(val => {
          console.log('สำเร็จ');
          $('#ModalDeleteProjectSaleBudgetComplete').modal('show');
          this.LoadProjectSaleBudget();
          this.OnLoadCountProjectSaleBudgetList();
        });

      }
    }

  }

  btnClick_deleteProjectSaleBudget(id, auth_token): Observable<ProjectSaleBudgetInfo[]> {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };
    var objectjson = {};
    objectjson['ProjectSaleBudgetID'] = id;

    let strjsonCusInfo = JSON.stringify(objectjson);

    return this.httpClient.post<ProjectSaleBudgetInfo[]>(this.baseurl + "ProjectSaleBudget/DeleteProjectSaleBudget", strjsonCusInfo, httpOptions);

  }

  expenseclaims_deleteProjectSaleBudget(id, auth_token): Observable<ProjectSaleBudgetInfo[]> {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };
    var objectjson = {};
    objectjson['ProjectSaleBudgetID'] = id;

    let strjsonCusInfo = JSON.stringify(objectjson);

    return this.httpClient.post<ProjectSaleBudgetInfo[]>(this.expense_baseurl + "ProjectSaleBudget/DeleteProjectSaleBudget", strjsonCusInfo, httpOptions);

  }

  OnDeleteProjectSaleBudgetAttachedFileClick(elem) {
    let dataInfo = $(elem).parent().data();
    if (Object.keys(dataInfo).length > 0) {
      //Confirm to delete
      this.modalDocInfo = dataInfo;
      this.modalDocName = dataInfo.documentname;
      $('#ModalConfirmDeleteProjectSaleBudgetAttachedFile').modal();
    }
  }

  async DeleteProjectSaleBudgetAttachedFile() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageProjectSaleBudgetNumber - 1) * environment.PageSize;

      var objectjson = {};
      objectjson['ProjectSaleBudgetAttachedFileID'] = this.modalDocInfo.documentid;

      let strjson = JSON.stringify(objectjson);
      this.httpClient
        .post<boolean>(this.baseurl + "ProjectSaleBudgetAttachedFile/DeleteProjectSaleBudgetAttachedFile",
          strjson, httpOptions)
        .subscribe({
          next: data => {
            if (data) {
              this.titlemodal = "Success";
              this.detailmodal = "The attached file has been deleted."
              this.LoadProjectSaleBudgetAttachedFile(this.hidprojectsalebudgetId);
            } else {
              this.titlemodal = "Sorry";
              this.detailmodal = "Delete fail."
            }
          },
          error: error => {
            console.error('There was an error!', error);
          }
        });
    }
  }

  async btn_LoadProjectSaleBudgetAttachedFile(id) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      this.LoadProjectSaleBudgetAttachedFileList(id, auth_token)
        .subscribe({
          next: data => {
            this.ProjectSaleBudgetAttachedFileList = data;
            $('#modalProjectSaleBudgetAttachedFile').modal('show');
          },
          error: error => {
            console.error('There was an error!', error);
          }
        })
    }
  }

  async btnClick_deleteProjectSaleBudgetitem(id) {

    if (confirm("Are you sure you want to delete this Sale Budget ?")) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        this.btnClick_deleteProjectSaleBudget(parseInt(id), auth_token).toPromise()
          .then(
            data => {

              console.log('หลังรับค่า');

              // ยังไม่ใช้งาน
              //also delete for expense claims
              //  this.expenseclaims_deleteProjectSaleBudget(parseInt(id), auth_token);

              $('#ModalDeleteProjectSaleBudgetComplete').modal('show');
              this.LoadProjectSaleBudget();
              this.OnLoadCountProjectSaleBudgetList();
            }
          );

      }
    }

  }

  async btnClick_submitUpdateProjectSaleBudget() {
    this.ValidateInsertProjectSaleBudget();

    if (this.validatetxtProjectSaleBudgetGLName == 'True' || this.validatetxtProjectSaleBudgetAmount == 'True') {
      return;
    }
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['ProjectSaleBudgetID'] = this.hidprojectsalebudgetId;
      objectjson['ProjectSaleID'] = this._ParamProjectSaleID;
      objectjson['ProjectSaleBudgetGLCode'] = this.checkUndefinedString(this.txtProjectSaleBudgetGLName);
      objectjson['ProjectSaleBudgetAmount'] = this.txtProjectSaleBudgetAmount;
      objectjson['UpdateBy'] = this.checkUndefinedString(localStorage.getItem("EmpCode"));
      objectjson['FlagDelete'] = "N";

      let strjson = JSON.stringify(objectjson);

      this.isSubmitted = this.httpClient.post<ProjectSaleBudgetInfo[]>(this.baseurl + "ProjectSaleBudget/UpdateProjectSaleBudget", strjson, httpOptions)
        .subscribe(result => this.isSubmitted = result, failCb => {
          console.log("Insert fail")
        },
          async () => {
            console.log("Insert = " + this.isSubmitted)


            // ยังไม่ใช้งาน
            ////also update in expense claims
            //this.expenseclaims_submitUpdateProjectSaleBudget()

            this.OnCreating('n');

            if (!!this.projectsaleBudgetFilesToUpload && this.projectsaleBudgetFilesToUpload.length > 0) {
              var isUploadSuccess = await this.UploadProjectSaleBudgetAttachedFilesToServer(this.projectsaleBudgetFilesToUpload);
              if (isUploadSuccess) {
                for (const val of this.projectsaleBudgetFilesToUpload) {
                  await this.InsertProjectSaleBudgetAttachedFile(val.name, this.projectsaleBudgetPathFile + "\\" + val.name, this.isSubmitted)
                }
              }

              $('#ModalProjectSaleBudgetEditComplete').modal();
              this.IsClearList = "true";
              this.projectsaleBudgetFilesToUpload = [];
              this.OnCreating('n');
              this.LoadProjectSaleBudget();
              this.LoadProjectSaleBudgetAttachedFile(this.isSubmitted);
              this.OnLoadCountProjectSaleBudgetList();
            }
            else {
              $('#ModalProjectSaleBudgetEditComplete').modal();
              this.IsClearList = "false";
              this.projectsaleBudgetFilesToUpload = [];
              this.OnCreating('n');
              this.LoadProjectSaleBudget();
              this.LoadProjectSaleBudgetAttachedFile(this.isSubmitted);
              this.OnLoadCountProjectSaleBudgetList();
            }
          }
        )
    }
  }

  async expenseclaims_submitUpdateProjectSaleBudget() {

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['ProjectSaleBudgetID'] = this.hidprojectsalebudgetId;
      objectjson['ProjectSaleID'] = this._ParamProjectSaleID;
      objectjson['ProjectSaleBudgetGLCode'] = this.checkUndefinedString(this.txtProjectSaleBudgetGLName);
      objectjson['ProjectSaleBudgetAmount'] = this.txtProjectSaleBudgetAmount;
      objectjson['UpdateBy'] = this.checkUndefinedString(localStorage.getItem("EmpCode"));
      objectjson['FlagDelete'] = "N";

      let strjson = JSON.stringify(objectjson);

      this.isSubmitted = this.httpClient.post<ProjectSaleBudgetInfo[]>(this.expense_baseurl + "ProjectSaleBudget/UpdateProjectSaleBudget", strjson, httpOptions)
        .subscribe(result => this.isSubmitted = result, failCb => {
          console.log("Insert fail")
        },
          async () => {
            console.log("Insert to expense claims = " + this.isSubmitted)

          }
        )
    }
  }

  OnEditing(flag) {
    if (flag == 'y') {
    } else if (flag == 'n') {
      $('#ModalProjectSaleBudget').modal('hide');
      $('#ModalProjectSaleCost').modal('hide');
    }

  }

  // region ProjectSaleCost event and function
  async LoadProjectSaleCost() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      this.LoadProjectSaleCostList(auth_token)

        .subscribe({
          next: data => {
            this.ProjectSaleCostList = data;
            this.hidcouchk = this.ProjectSaleCostList.length.toString();
          },
          error: error => {
            console.error('There was an error!', error);
          }
        });
    }
  }

  LoadProjectSaleCostList(auth_token): Observable<ProjectSaleCostInfo[]> {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    let offset = (this.currentPageProjectSaleCostNumber - 1) * environment.PageSize;

    var objectjson = {};
    objectjson['ProjectSaleID'] = this._ParamProjectSaleID;
    objectjson['FlagDelete'] = "N";
    objectjson['rowFetch'] = environment.PageSize;
    objectjson['rowOFFSet'] = offset;


    let strjson = JSON.stringify(objectjson);

    return this.httpClient
      .post<ProjectSaleCostInfo[]>(this.baseurl + "ProjectSaleCost/GetProjectSaleCost",
        strjson, httpOptions)

  }

  OnLoadCountProjectSaleCostList() {
    //call function load count all ticket list on hand current role user
    this.LoadCountProjectSaleCostList()
  }

  async LoadCountProjectSaleCostList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['ProjectSaleID'] = this._ParamProjectSaleID;
      objectjson['FlagDelete'] = "N";

      let strjson = JSON.stringify(objectjson);
      this.httpClient.post<number>(this.baseurl + "ProjectSaleCost/GetCountProjectSaleCost", strjson, httpOptions)
        .toPromise()
        .then(data => {
          this.ProjectSaleCostTotal = data;
          this.totalProjectSaleCostPages = Math.ceil(this.ProjectSaleCostTotal / environment.PageSize);

          if (data == 0) {
            this.currentPageProjectSaleCostNumber = 0;
          }
        })
    }
  }

  async OnLoadProjectSaleCostList(traget = null) {

    if (traget != null) { // check call function from change page or onloadfrist
      this.LoadProjectSaleCostUpdatePagination(traget);
    }

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      this.LoadProjectSaleCostList(auth_token).subscribe(data => { //call function load ticket list on hand current role user
        this.ProjectSaleCostList = data;
      })
    }
  }

  LoadProjectSaleCostUpdatePagination(traget) {
    this.currentPageProjectSaleCostNumber = traget.currentPageNumber;
    this.totalProjectSaleCostPages = traget.totalPages;
  }

  chkallProjectSaleCostclick(traget) {
    var check = $(traget.currentTarget).is(":checked");

    $('[name="checkboxProjectSaleCost"]').prop('checked', check);

  }

  btnClick_onCreateProjectSaleCost() {
    this.IsClearProjectSaleCostAttachedmentList = "false";
    $('#ModalProjectSaleCost').modal('show');
    this.txtProjectSaleCostItemCode = "";
    this.txtProjectSaleCostItemName = "";
    this.txtProjectSaleCostType = "";
    this.txtProjectSaleCostQuantity = 0;
    this.txtProjectSaleCostUnit = "";
    this.txtProjectSaleCostUnitCost = 0;
    this.txtProjectSaleCostAmount = 0;
    this.ProjectSaleCostAttachedmentList = [];
    this.isOnUpdate = false;

    this.validatetxtProjectSaleCostItemCode = 'False';
    this.validatetxtProjectSaleCostItemName = 'False';
    this.validatetxtProjectSaleCostType = 'False';
    this.validatetxtProjectSaleCostQuantity = 'False';
    this.validatetxtProjectSaleCostUnitCost = 'False';
  }

  DragFilesProjectCostAttachedmentFinished(returnObj) {

    if (!!returnObj.Message) {
      alert(returnObj.Message)
    } else {
      this.projectsaleCostFilesToUpload = returnObj.Files;
      this.projectsaleCostPathFile = returnObj.PathFile;
    }
  }

  CalculateAmount() {
    this.txtProjectSaleCostAmount = this.txtProjectSaleCostQuantity * this.txtProjectSaleCostUnitCost;
  }

  async btnClick_submitInsertProjectSaleCost() {
    this.ValidateInsertProjectSaleCost();

    if (this.validatetxtProjectSaleCostItemCode == 'True' || this.validatetxtProjectSaleCostItemName == 'True' || this.validatetxtProjectSaleCostType == 'True' || this.validatetxtProjectSaleCostQuantity == 'True' || this.validatetxtProjectSaleCostUnitCost == 'True') {
      return;
    }
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['ProjectSaleID'] = this._ParamProjectSaleID;
      objectjson['ProjectSaleCostItemCode'] = this.checkUndefinedString(this.txtProjectSaleCostItemCode);
      objectjson['ProjectSaleCostItemName'] = this.checkUndefinedString(this.txtProjectSaleCostItemName);
      objectjson['ProjectSaleCostType'] = this.checkUndefinedString(this.txtProjectSaleCostType);

      if (this.txtProjectSaleCostQuantity == null || this.txtProjectSaleCostQuantity.toString() == "") {
        objectjson['ProjectSaleCostQuantity'] = 0;
      } else {
        objectjson['ProjectSaleCostQuantity'] = this.txtProjectSaleCostQuantity;
      }

      objectjson['ProjectSaleCostUnit'] = this.checkUndefinedString(this.txtProjectSaleCostUnit);

      if (this.txtProjectSaleCostUnitCost == null || this.txtProjectSaleCostUnitCost.toString() == "") {
        objectjson['ProjectSaleCostUnitCost'] = 0;
      } else {
        objectjson['ProjectSaleCostUnitCost'] = this.txtProjectSaleCostUnitCost;
      }

      if (this.txtProjectSaleCostAmount == null || this.txtProjectSaleCostAmount.toString() == "") {
        objectjson['ProjectSaleCostAmount'] = 0;
      } else {
        objectjson['ProjectSaleCostAmount'] = this.txtProjectSaleCostAmount;
      }

      objectjson['CreateBy'] = this.checkUndefinedString(localStorage.getItem("EmpCode"));
      objectjson['FlagDelete'] = "N";

      let strjson = JSON.stringify(objectjson);

      this.isSubmitted = this.httpClient.post<ProjectSaleBudgetInfo[]>(this.baseurl + "ProjectSaleCost/InsertProjectSaleCost", strjson, httpOptions)
        .subscribe(result => this.isSubmitted = result, failCb => {
          console.log("Insert fail")
        },
          async () => {
            console.log("Insert = " + this.isSubmitted)

            this.OnCreating('n');

            if (!!this.projectsaleCostFilesToUpload && this.projectsaleCostFilesToUpload.length > 0) {
              var isUploadSaleCostAttachedSuccess = await this.UploadProjectSaleCostAttachedFileToServer(this.projectsaleCostFilesToUpload)
              if (isUploadSaleCostAttachedSuccess) {
                for (const val of this.projectsaleCostFilesToUpload) {
                  await this.InsertProjectSaleCostAttachedment(val.name, this.projectsaleCostPathFile + "\\" + val.name, this.isSubmitted)
                }
                $('#ModalProjectSaleCostCreateComplete').modal();
                this.IsClearProjectSaleCostAttachedmentList = "true";
                this.projectsaleCostFilesToUpload = [];
                this.OnCreating('n');
                this.LoadProjectSaleCost();
                this.LoadProjectSaleCostAttachedment(this.isSubmitted);
                this.OnLoadCountProjectSaleCostList();
              }
            }
            else {
              this.LoadProjectSaleCost();
              this.LoadProjectSaleCostAttachedment(this.isSubmitted);
              this.OnLoadCountProjectSaleCostList();
              this.IsClearProjectSaleCostAttachedmentList = "false";
              this.projectsaleCostFilesToUpload = [];
              this.OnCreating('n');
              $('#ModalProjectSaleCostCreateComplete').modal();
            }
          }
        )
    }
  }

  ValidateInsertProjectSaleCost() {
    if (this.txtProjectSaleCostItemCode == "" || this.txtProjectSaleCostItemCode == null) {
      this.validatetxtProjectSaleCostItemCode = 'True';
    } else {
      this.validatetxtProjectSaleCostItemCode = 'False';
    }

    if (this.txtProjectSaleCostItemName == "" || this.txtProjectSaleCostItemName == null) {
      this.validatetxtProjectSaleCostItemName = 'True';
    } else {
      this.validatetxtProjectSaleCostItemName = 'False';
    }

    if (this.txtProjectSaleCostType == "" || this.txtProjectSaleCostType == null) {
      this.validatetxtProjectSaleCostType = 'True';
    } else {
      this.validatetxtProjectSaleCostType = 'False';
    }

    if (this.txtProjectSaleCostQuantity.toString() == "" || this.txtProjectSaleCostQuantity == null || this.txtProjectSaleCostQuantity < 0) {
      this.validatetxtProjectSaleCostQuantity = 'True';
    } else {
      this.validatetxtProjectSaleCostQuantity = 'False';
    }

    if (this.txtProjectSaleCostUnitCost.toString() == "" || this.txtProjectSaleCostUnitCost == null || this.txtProjectSaleCostUnitCost < 0) {
      this.validatetxtProjectSaleCostUnitCost = 'True';
    } else {
      this.validatetxtProjectSaleCostUnitCost = 'False';
    }
  }

  async UploadProjectSaleCostAttachedFileToServer(files) {

    if (!files || files.length === 0) {
      alert("Please browse file at least one.")
      return false;
    }
    let filesToUpload: File[] = files;

    await Array.from(filesToUpload).map((file, index) => {
      // push uoload list
      const formData = new FormData();
      formData.append("pathfile", this.projectsaleCostPathFile);
      formData.append('file' + index, file, file.name);
      this.httpClient.post(this.baseurl + "api/upload", formData, { reportProgress: true, observe: 'events' })
        .subscribe(event => {
          if (event.type === HttpEventType.UploadProgress) {
            var progress = Math.round(100 * event.loaded / event.total);

            if (progress == 100) {

            }

          } else if (event.type === HttpEventType.Response) {
          }
        });



    });

    return true;
  }

  async InsertProjectSaleCostAttachedment(Filename, pathfile, projectsalecostid) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['ProjectSaleCostID'] = projectsalecostid;
      objectjson['ProjectSaleCostAttachedmentFileName'] = Filename;
      objectjson['ProjectSaleCostAttachedmentPathFile'] = pathfile;
      objectjson['FlagDelete'] = "N";
      objectjson['CreateBy'] = localStorage.getItem("EmpCode");




      let strjson = JSON.stringify(objectjson);

      this.isProjectSaleCostAttachedmentSubmitted = this.httpClient.post<ProjectSaleBudgetAttachedFileInfo[]>(this.baseurl + "ProjectSaleCostAttachedment/InsertProjectSaleCostAttachedment", strjson, httpOptions)

        .subscribe(result => this.isProjectSaleCostAttachedmentSubmitted = result, failCb => {
          console.log("Insert fail")
        },
          () => {
            console.log("Insert = " + this.isProjectSaleCostAttachedmentSubmitted)
          }
        )
    }
  }

  async LoadProjectSaleCostAttachedment(projectsalecostid) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      this.LoadProjectSaleCostAttachedmentList(projectsalecostid, auth_token)
        .subscribe({
          next: data => {
            this.ProjectSaleCostAttachedmentList = data;
          },
          error: error => {
            console.error('There was an error!', error);
          }
        });
    }
  }

  LoadProjectSaleCostAttachedmentList(projectsalecostid, auth_token): Observable<ProjectSaleCostAttachedmentInfo[]> {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    var objectjson = {};


    objectjson['ProjectSaleCostID'] = projectsalecostid;
    objectjson['FlagDelete'] = "N";

    let strjson = JSON.stringify(objectjson);
    return this.httpClient
      .post<ProjectSaleCostAttachedmentInfo[]>(this.baseurl + "ProjectSaleCostAttachedment/GetProjectSaleCostAttachedment",
        strjson, httpOptions)

  }

  async btnClick_onDeleteProjectSaleCostList() {

    if (confirm("Are you sure you want to delete this Sale Cost?")) {

      var checkboxProjectSaleCost = $('[name="checkboxProjectSaleCost"]:checked');

      let num = checkboxProjectSaleCost.length;
      let observableBatch = [];
      let observableBatch1 = [];
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        for (var i = 0; i < num; i++) {

          var ProjectSaleCostcurrent = <HTMLInputElement>checkboxProjectSaleCost[i];
          observableBatch.push(this.btnClick_deleteProjectSaleCost(parseInt(ProjectSaleCostcurrent.value), auth_token).toPromise().then(val => {
          }));

          var ProjectSaleCostAttachedmentcurrent = <HTMLInputElement>checkboxProjectSaleCost[i];
          observableBatch1.push(this.btnClick_deleteProjectSaleCostAttachedmentbyProjectSaleCostID(parseInt(ProjectSaleCostcurrent.value), auth_token).toPromise().then(val => {
          }));

        }

        Promise.all(observableBatch).then(val => {
          console.log('สำเร็จ');
          $('#ModalDeleteProjectSaleBudgetComplete').modal('show');
          this.LoadProjectSaleCost();
          this.OnLoadCountProjectSaleCostList();
        });
      }

    }

  }

  btnClick_deleteProjectSaleCost(id, auth_token): Observable<ProjectSaleCostInfo[]> {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };
    var objectjson = {};
    objectjson['ProjectSaleCostID'] = id;

    let strjsonCusInfo = JSON.stringify(objectjson);

    return this.httpClient.post<ProjectSaleCostInfo[]>(this.baseurl + "ProjectSaleCost/DeleteProjectSaleCost", strjsonCusInfo, httpOptions);

  }

  btnClick_deleteProjectSaleCostAttachedmentbyProjectSaleCostID(id, auth_token): Observable<ProjectSaleCostAttachedmentInfo[]> {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };
    var objectjson = {};
    objectjson['ProjectSaleCostID'] = id;

    let strjsonCusInfo = JSON.stringify(objectjson);

    return this.httpClient.post<ProjectSaleCostAttachedmentInfo[]>(this.baseurl + "ProjectSaleCostAttachedment/DeleteProjectSaleCostAttachedmentbyProjectCostID", strjsonCusInfo, httpOptions);
  }


  async btn_LoadProjectSaleCostAttachedment(id) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      this.LoadProjectSaleCostAttachedmentList(id, auth_token)
        .subscribe({
          next: data => {
            this.ProjectSaleCostAttachedmentList = data;
            $('#modalProjectSaleCostAttachedment').modal('show');
          },
          error: error => {
            console.error('There was an error!', error);
          }
        });
    }
  }

  OnDeleteProjectSaleCostAttachedmentClick(elem) {
    let dataInfo = $(elem).parent().data();
    if (Object.keys(dataInfo).length > 0) {
      //Confirm to delete
      this.modalDocInfo = dataInfo;
      this.modalDocName = dataInfo.documentname;
      $('#ModalConfirmDeleteProjectSaleCostAttachedment').modal();
    }
  }

  async DeleteProjectSaleCostAttachedment() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageProjectSaleCostNumber - 1) * environment.PageSize;

      var objectjson = {};
      objectjson['ProjectSaleCostAttachedmentID'] = this.modalDocInfo.documentid;

      let strjson = JSON.stringify(objectjson);
      this.httpClient
        .post<boolean>(this.baseurl + "ProjectSaleCostAttachedment/DeleteProjectSaleCostAttachedment",
          strjson, httpOptions)
        .subscribe({
          next: data => {
            if (data) {
              this.titlemodal = "Success";
              this.detailmodal = "The attached file has been deleted."
              this.LoadProjectSaleCostAttachedment(this.hidprojectsalecostId);
            } else {
              this.titlemodal = "Sorry";
              this.detailmodal = "Delete fail."
            }
          },
          error: error => {
            console.error('There was an error!', error);
          }
        })
    }
  }

  async btnClick_deleteProjectSaleCostitem(id) {

    if (confirm("Are you sure you want to delete this Sale Cost ?")) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        this.btnClick_deleteProjectSaleCost(parseInt(id), auth_token).toPromise()
          .then(
            data => {
              console.log('หลังรับค่า');
              $('#ModalDeleteProjectSaleCostComplete').modal('show');
              this.LoadProjectSaleCost();
              this.OnLoadCountProjectSaleCostList();
            }
          );

      }
    }

  }

  btnClick_onUpdateProjectSaleCost(id) {
    this.isOnUpdate = true;
    this.IsClearProjectSaleCostAttachedmentList = "false";

    this.validatetxtProjectSaleCostItemCode = 'False';
    this.validatetxtProjectSaleCostItemName = 'False';
    this.validatetxtProjectSaleCostType = 'False';
    this.validatetxtProjectSaleCostQuantity = 'False';
    this.validatetxtProjectSaleCostUnitCost = 'False';

    let index = this.ProjectSaleCostList.findIndex(x => x.ProjectSaleCostID == id);

    this.txtProjectSaleCostItemCode = this.ProjectSaleCostList[index].ProjectSaleCostItemCode != null ? this.ProjectSaleCostList[index].ProjectSaleCostItemCode : null
    this.txtProjectSaleCostItemName = this.ProjectSaleCostList[index].ProjectSaleCostItemName != null ? this.ProjectSaleCostList[index].ProjectSaleCostItemName : null
    this.txtProjectSaleCostType = this.ProjectSaleCostList[index].ProjectSaleCostType != null ? this.ProjectSaleCostList[index].ProjectSaleCostType : null
    this.txtProjectSaleCostQuantity = this.ProjectSaleCostList[index].ProjectSaleCostQuantity != null ? this.ProjectSaleCostList[index].ProjectSaleCostQuantity : null
    this.txtProjectSaleCostUnit = this.ProjectSaleCostList[index].ProjectSaleCostUnit != null ? this.ProjectSaleCostList[index].ProjectSaleCostUnit : null
    this.txtProjectSaleCostUnitCost = this.ProjectSaleCostList[index].ProjectSaleCostUnitCost != null ? this.ProjectSaleCostList[index].ProjectSaleCostUnitCost : null
    this.txtProjectSaleCostAmount = this.ProjectSaleCostList[index].ProjectSaleCostAmount != null ? this.ProjectSaleCostList[index].ProjectSaleCostAmount : null
    this.hidprojectsalecostId = this.ProjectSaleCostList[index].ProjectSaleCostID;

    this.LoadProjectSaleCostAttachedment(id);

    $('#ModalProjectSaleCost').modal();
  }

  async btnClick_submitUpdateProjectSaleCost() {
    this.ValidateInsertProjectSaleCost();

    if (this.validatetxtProjectSaleCostItemCode == 'True' || this.validatetxtProjectSaleCostItemName == 'True' || this.validatetxtProjectSaleCostType == 'True' || this.validatetxtProjectSaleCostQuantity == 'True' || this.validatetxtProjectSaleCostUnitCost == 'True') {
      return;
    }
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['ProjectSaleCostID'] = this.hidprojectsalecostId;
      objectjson['ProjectSaleID'] = this._ParamProjectSaleID;
      objectjson['ProjectSaleCostItemCode'] = this.checkUndefinedString(this.txtProjectSaleCostItemCode);
      objectjson['ProjectSaleCostItemName'] = this.checkUndefinedString(this.txtProjectSaleCostItemName);
      objectjson['ProjectSaleCostType'] = this.checkUndefinedString(this.txtProjectSaleCostType);

      if (this.txtProjectSaleCostQuantity == null || this.txtProjectSaleCostQuantity.toString() == "") {
        objectjson['ProjectSaleCostQuantity'] = 0;
      } else {
        objectjson['ProjectSaleCostQuantity'] = this.txtProjectSaleCostQuantity;
      }

      objectjson['ProjectSaleCostUnit'] = this.checkUndefinedString(this.txtProjectSaleCostUnit);

      if (this.txtProjectSaleCostUnitCost == null || this.txtProjectSaleCostUnitCost.toString() == "") {
        objectjson['ProjectSaleCostUnitCost'] = 0;
      } else {
        objectjson['ProjectSaleCostUnitCost'] = this.txtProjectSaleCostUnitCost;
      }

      if (this.txtProjectSaleCostAmount == null || this.txtProjectSaleCostAmount.toString() == "") {
        objectjson['ProjectSaleCostAmount'] = 0;
      } else {
        objectjson['ProjectSaleCostAmount'] = this.txtProjectSaleCostAmount;
      }

      objectjson['UpdateBy'] = this.checkUndefinedString(localStorage.getItem("EmpCode"));
      objectjson['FlagDelete'] = "N";

      let strjson = JSON.stringify(objectjson);

      this.isSubmitted = this.httpClient.post<ProjectSaleCostInfo[]>(this.baseurl + "ProjectSaleCost/UpdateProjectSaleCost", strjson, httpOptions)
        .subscribe(result => this.isSubmitted = result, failCb => {
          console.log("Update fail")
        },
          async () => {
            console.log("Insert = " + this.isSubmitted)

            this.OnCreating('n');

            if (!!this.projectsaleCostFilesToUpload && this.projectsaleCostFilesToUpload.length > 0) {
              var isUploadSaleCostAttachedSuccess = await this.UploadProjectSaleCostAttachedFileToServer(this.projectsaleCostFilesToUpload)
              if (isUploadSaleCostAttachedSuccess) {
                for (const val of this.projectsaleCostFilesToUpload) {
                  await this.InsertProjectSaleCostAttachedment(val.name, this.projectsaleCostPathFile + "\\" + val.name, this.isSubmitted)
                }
                $('#ModalProjectSaleCostCreateComplete').modal();
                this.IsClearProjectSaleCostAttachedmentList = "true";
                this.projectsaleCostFilesToUpload = [];
                this.OnCreating('n');
                this.LoadProjectSaleCost();
                this.LoadProjectSaleCostAttachedment(this.isSubmitted);
                this.OnLoadCountProjectSaleCostList();
              }
            }
            else {
              $('#ModalProjectSaleCostCreateComplete').modal();
              this.IsClearProjectSaleCostAttachedmentList = "false";
              this.projectsaleCostFilesToUpload = [];
              this.OnCreating('n');
              this.LoadProjectSaleCost();
              this.LoadProjectSaleCostAttachedment(this.isSubmitted);
              this.OnLoadCountProjectSaleCostList();
            }
          }
        )
    }
  }


  gencoderesult: string = "";
  async OnBtnGenLeadCodeClick() {
    //Connect to server
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['ProjectSaleId'] = this._ParamProjectSaleID;

      let strjson = JSON.stringify(objectjson);
      this.httpClient
        .post<boolean>(this.baseurl + "ProjectSale/ReGenerateLeadCode",
          strjson, httpOptions)
        .toPromise().then(
          result => {

            if (result) {
              this.gencoderesult = "successfully";
              $('#ModalGenCodeComplete').modal();
            }
            else {
              this.gencoderesult = "fail";
              $('#ModalGenCodeComplete').modal();
            }
          }
        )
    }
  }

  removeCommas(ctrl) {
    var result = ctrl.value.toString().replace(/,/g, '');
    ctrl.setValue(result);
  }

  replaceCommas(ctrl) {
    var result = ctrl.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    if (result.indexOf('.') < 0) {
      result += ".00";
    }
    ctrl.setValue(result);
  }

  // ----------------------- Function Assign Member Zone -----------------------------------------
  createItemAssignMemberDefault(): FormGroup {
    return this.formBuilder.group({
      ProjectMemberId: [null],
      EmpName: [null, Validators.required],
      EmpNameDisplay: [null],
      PositionInProject: [null],
      PositionInProjectDisplay: [null],
      JobTitle: [null],
      NickName: [''],
      Phone: [''],
      Email: [''],
      FlagRemove: [false]
    },
    );
  }

  createItemAssignMember(ProjectMemberitem: ProjectMemberInfo): FormGroup {
    return this.formBuilder.group({
      ProjectMemberId: [ProjectMemberitem.Id],
      EmpName: [ProjectMemberitem.EmpCode, Validators.required],
      EmpNameDisplay: [ProjectMemberitem.EmpNameDisplay],
      PositionInProject: [''],
      PositionInProjectDisplay: [''],
      JobTitle: [''],
      NickName: [''],
      Phone: [''],
      Email: [''],
      FlagRemove: [false]
    },
    );
  }


  async loadAssignMemberLead() {
    // clear old
    this.itemsAssignMemberForm_array.clear();

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

      objectjson['ProjectCode'] = this.ProjectSaleCode;
      objectjson['ProjectType'] = 'Lead';

      let strjson = JSON.stringify(objectjson);

      await this.httpClient.post<ProjectMemberInfo[]>(this.baseurl + "ProjectMember/GetProjectMember", strjson, httpOptions)
        .toPromise().then((data) => {

          // get emp manager cuurent project (Lookup Business Development (BA) from data on object property LookupCode = 5)
          var listempmanager = data.filter(function (obj) {
            return obj.PositionInProject == '5';
          });

          if (listempmanager.length) {
            this.EmpManager = listempmanager[0].EmpCode;
          }


          // Remove Lookup Business Development from data on object property LookupCode = 5
          data = data.filter(function (obj) {
            return obj.PositionInProject !== '5';
          });

          this.AssignMemberLeadList = data;


          // if not empty Assign Member and Cuurent user is BD : set default
          if (this.AssignMemberLeadList.length <= 0 && this.IsShowForThisBDOnlyANDStateApproveLead == true) {
            this.itemsAssignMemberForm_array.push(this.createItemAssignMemberDefault());
          }

        });
    }
  }

  async loadEmpList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      let strjson = JSON.stringify(objectjson);

      await this.httpClient.post<EmpInfo[]>(this.baseurl + "Employee/GetEmployeeCriteria", strjson, httpOptions)
        .toPromise().then((data) => {
          // get emplist for assign member without cuurent manager && member is internal
          this.EmployeeList = data.filter(obj => {
            return obj.EmpCode !== this.EmpManager && obj.EmpType == '1';
          });

          // load detail emp for assign member
          this.AssignMemberLeadList.forEach((traget, indextraget) => {
            this.itemsAssignMemberForm_array.push(this.createItemAssignMember(traget));
            //load detail of Emp
            this.onChanges(indextraget)
          });
        });
    }
  }

  addAssignMemberItem(): void {
    this.itemsAssignMemberForm_array.push(this.createItemAssignMemberDefault());
  }

  removeAssignMemberItem(indexitem): void {
    // get id cuurent AssignMember
    var cuurentIdAssignMember = this.itemsAssignMemberForm_array.at(indexitem).value.ProjectMemberId;

    if (cuurentIdAssignMember != null) {
      // set FlagRemove Assign Member
      this.itemsAssignMemberForm_array.at(indexitem).value.FlagRemove = true;
    } else {
      // remove from Array
      this.itemsAssignMemberForm_array.removeAt(indexitem);
    }


  }

  // get count remove Assign Member for Display No.
  getcountremove() {
    return this.itemsAssignMemberForm_array.controls.filter(function (obj) {
      return obj.value.FlagRemove === true;
    }).length;
  }

  async onChanges(idx, checkForDuplicate: boolean = false, loadFromModal: boolean = false) {
    //this.selectEmpName = empcode;

    let empcode = '';
    let empselectbox = this.itemsAssignMemberForm_array.controls[idx].get('EmpName');

    if (loadFromModal) {
      empcode = this.selectedemp.EmpCode;
    } else {
      empcode = this.itemsAssignMemberForm_array.controls[idx].get('EmpName').value;
    }


    var duplicate: boolean = false;
    if (checkForDuplicate) {
      var listcontrols = this.itemsAssignMemberForm_array.controls;
      listcontrols.forEach((itemcurrent, index) => {
        if (itemcurrent.value.EmpName == empcode && index != idx) {
          duplicate = true;
        }
      });

    }

    if (!duplicate) {
      var jobtitle = this.EmployeeList.find(x => { return x.EmpCode == empcode }).JobTitle;
      var position = this.EmployeeList.find(x => { return x.EmpCode == empcode }).PositionName;
      var nickname = this.EmployeeList.find(x => { return x.EmpCode == empcode }).NickName;
      var mobile = this.EmployeeList.find(x => { return x.EmpCode == empcode }).Mobile;
      var mails = this.EmployeeList.find(x => { return x.EmpCode == empcode }).Mail;
      //var positions = this.selectEmpName.find(x => { return x.EmpCode == empcode }).PositionCode;
      //var positions = this.selectEmpName.find(x => { return x.EmpCode == empcode }).PositionName;

      var EmpJobTitle = this.itemsAssignMemberForm_array.controls[idx].get('JobTitle');
      var EmpPosition = this.itemsAssignMemberForm_array.controls[idx].get('PositionInProjectDisplay');
      var EmpNickname = this.itemsAssignMemberForm_array.controls[idx].get('NickName');
      var EmpPhone = this.itemsAssignMemberForm_array.controls[idx].get('Phone');
      var EmpMail = this.itemsAssignMemberForm_array.controls[idx].get('Email');

      EmpJobTitle.setValue(jobtitle);
      EmpPosition.setValue(position);
      EmpNickname.setValue(nickname)
      EmpPhone.setValue(mobile)
      EmpMail.setValue(mails)

      if (loadFromModal) {
        let code = this.EmployeeList.find(x => { return x.EmpCode == empcode }).EmpCode;

        empselectbox.setValue(code);
      }
    } else {
      this.removeAssignMemberItem(idx);
      this.addAssignMemberItem();
      alert("You cannnot select duplicate employee.");
    }

  }


  async ReLoadAssignMember() {
    // set to default
    this.AssignMemberForm.markAsUntouched();

    // ------------------- Assign Member Zone -------------------------------
    // Load Assgin Member
    await this.loadAssignMemberLead();
    // Load Emp List for Assign Member
    await this.loadEmpList();
    //Load PositionInProject (Lookup MASTERPROJECTROLE) for Assgin Member
    await this.GlobalService.loadLookup('MASTERPROJECTROLE').then((data) => {
      // Remove Lookup Business Development from data on object property LookupCode = 5
      data = data.filter(function (obj) {
        return obj.LookupCode !== '5';
      });

      this.PositionInProjectList = data;
    });

    await this.loadCountActiveProjectMember();
    // ------------------- Assign Member Zone -------------------------------
  }

  async btnClick_submitSaveAssignMember() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      if (this.AssignMemberForm.valid) {
        console.log('SaveAssignMember submitted');
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };
        let listcontrols = this.itemsAssignMemberForm_array.controls;
        let arrayinsert = [];
        listcontrols.forEach((itemcurrent) => {
          let objectjson = {};

          objectjson['Id'] = itemcurrent.value.ProjectMemberId;
          objectjson['ProjectCode'] = this.ProjectSaleCode;
          objectjson['ProjectType'] = "Lead";

          objectjson['EmpCode'] = itemcurrent.value.EmpName;

          let EmpRole = this.EmployeeList.find(x => { return x.EmpCode == itemcurrent.value.EmpName }).RoleCode;

          objectjson['EmpRole'] = EmpRole;
          //objectjson['PositionInProject'] = itemcurrent.value.PositionInProject;
          objectjson['FlagRemoveAssignMemberFromClient'] = itemcurrent.value.FlagRemove;

          objectjson['UpdateBy'] = this.checkUndefinedString(localStorage.getItem("EmpCode"));
          arrayinsert.push(objectjson);
        });

        let strjson = JSON.stringify(arrayinsert);
        this.isSubmitted = this.httpClient.post<any>(this.baseurl + "ProjectMember/UpdateAssignMemberProject", strjson, httpOptions)

          .subscribe(result => this.isSubmitted = result, failCb => {
            console.log("SaveAssignMember fail")
            this.titlemodal = 'Save Assign Member fail.';
            this.detailmodal = 'Save Assign Member was saved fail.';
            $('#ModalError').modal();
          },
            async () => {
              console.log("SaveAssignMember = " + this.isSubmitted)

              // ยังไม่ใช้งาน
              //save to expense
              //this.expenseclaims_submitSaveAssignMember(arrayinsert);

              await this.ReLoadAssignMember();
              this.loading(false);
              this.titlemodal = 'Saving Assign Member done.';
              this.detailmodal = 'Your member was updated successfully.';
              $('#ModalComplate').modal();
            }
          )

      } else {
        this.GlobalService.markFormGroupTouched(this.AssignMemberForm);
      }
    }
  }

  async expenseclaims_submitSaveAssignMember(array) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      if (true) {
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };

        let strjson = JSON.stringify(array);
        this.isSubmitted = this.httpClient.post<any>(this.expense_baseurl + "ProjectMember/UpdateAssignMemberProject", strjson, httpOptions)

          .subscribe(result => this.isSubmitted = result, failCb => {
            console.log("SaveAssignMember fail")
          },
            async () => {
              console.log("SaveAssignMember = " + this.isSubmitted)
            }
          )

      }
    }
  }

  //Update Flag ProjectMember by Stat=1-8, Sub Stat=1-5-1
  async clickEventChangeFlag() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      console.log('ChageFlageProjectMember');
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
      //var listcontrols = this.itemsAssignMemberForm_array.controls;
      //var arrayinsert = [];
      //listcontrols.forEach((itemcurrent) => {
      var objectjson = {};
      objectjson['ProjectCode'] = this.ProjectSaleCode;
      objectjson['ProjectType'] = "Lead";

      //var EmpRole = this.EmployeeList.find(x => { return x.EmpCode == itemcurrent.value.EmpName }).RoleCode;

      //objectjson['EmpRole'] = EmpRole;
      //objectjson['PositionInProject'] = itemcurrent.value.PositionInProject;
      //objectjson['FlagProjectLead'] = this.txtFlagProjectLead;
      objectjson['FlagEmpActive'] = this.AssignMemberForm.get('txtFlagProjectLead').value ? 'Y' : 'N'

      objectjson['UpdateBy'] = this.checkUndefinedString(localStorage.getItem("EmpCode"));


      let strjson = JSON.stringify(objectjson);

      this.isSubmitted = this.httpClient.post<any>(this.baseurl + "ProjectMember/UpdateFlagMemberProject", strjson, httpOptions)

        .subscribe(result => this.isSubmitted = result, failCb => {
          console.log("SaveAssignMember fail")
          this.titlemodal = 'Update Flag Project Member fail.';
          this.detailmodal = 'Update Flag Project Member was saved fail.';
          $('#ModalError').modal();
        },
          async () => {
            console.log("UpdateFlagProjectMember Success")
            await this.ReLoadAssignMember();
            this.loading(false);
            this.titlemodal = 'Update Flag Project Member done.';
            this.detailmodal = 'Your Flag Project Member was updated successfully.';
            $('#ModalComplate').modal();
          }
        )
    }
  }

  //Count Active Flag ProjectMember
  async loadCountActiveProjectMember() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
      //debugger
      var objectjson = {};
      objectjson['ProjectCode'] = this.ProjectSaleCode;
      objectjson['ProjectType'] = 'Lead';
      let strjson = JSON.stringify(objectjson);

      return this.httpClient
        .post<number>(this.baseurl + "ProjectMember/GetCountActiveProjectMember",
          strjson, httpOptions)
        .toPromise().then((data) => {
          this.ckFlagProjectLead = data;
          console.log("Your data: ", this.ckFlagProjectLead);
        });
    }
  }

  selectedEmp(event) {
    console.log("SELECTED EMP")

    this.selectedemp = event[0];
    console.log(this.selectedemp)


  }

  empselect(num) {
    this.employeeselectrun = true;
    this.employeeselectreturnto = num;
    this.selectedemp = null;
    $('#ModalEmpSelect').modal();
  }

  async saveEmpSelect() {

    if (this.selectedemp != null) {
      // hide modal Assign PM
      $('#ModalEmpSelect').modal('hide');
      this.employeeselectrun = false;


      this.onChanges(this.employeeselectreturnto, true, true)

      this.selectedemp = null;

    } else {
      alert("Please select an employee")
    }

  }

  async loadEffortGroup() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

      objectjson['EffortProjectSaleCode'] = this.ProjectSaleCode;

      let strjson = JSON.stringify(objectjson);

      return await this.httpClient.post<EffortGroupInfo[]>(this.baseurl + "EffortGroup/GetEffortGroup", strjson, httpOptions)
        .toPromise()
    }
  }

  async btnAssignLeadProjectSaleClick() {
    // reset form
    this.AssignLeadForm.reset();
    // load ddl AssignPM
    await this.loadDDLAssignLead();

    // set current Assign PM
    this.AssignLeadForm.patchValue({
      ddlAssignLead: this.ProjectSaleList[0].ProjectSaleAssignTo,
    });

    // show modal Assign BD
    $('#ModalAssignProjectSale').modal();
  }

  async btnSubmitAssignLeadProjectSaleClick() {
    if (this.AssignLeadForm.valid) {
      // hide modal Assign BD
      $('#ModalAssignProjectSale').modal('hide');

      // save AssignPM
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {

        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };
        var EmpAssignLead = this.AssignLeadForm.get('ddlAssignLead').value;
        var EmpRoleAssignLead = $('#selectAssignLead option:selected').attr('emprolecode');

        var objectjson = {};

        objectjson['ProjectSaleId'] = this.ProjectSaleList[0].ProjectSaleId;
        objectjson['ProjectSaleAssignTo'] = this.checkUndefinedString(EmpAssignLead.toString());
        objectjson['ProjectSaleAssignBy'] = this.checkUndefinedString(this._EmpCode);
        //objectjson['ProjectSaleCreateBy'] = this.checkUndefinedString(EmpAssignLead.toString());
        objectjson['ProjectSaleUpdateBy'] = this.checkUndefinedString(localStorage.getItem("EmpCode"));

        let strjson = JSON.stringify(objectjson);


        this.isSubmitted = await this.httpClient.post<ProjectMemberInfo[]>(this.baseurl + "ProjectSale/AssignEmpProjectSale", strjson, httpOptions)

          .subscribe(result => this.isSubmitted = result, failCb => {
            console.log("Update fail")
            this.titlemodal = 'Update Assign fail.';
            this.detailmodal = 'Action Assign Lead was update fail.';

            $('#ModalError').modal();

          },
            async () => {
              console.log("Update = " + this.isSubmitted)

              this.titlemodal = 'Submit Assign Lead succeed.';
              this.detailmodal = 'Update Assign Lead completed.';

              $('#ModalComplate').modal();

              // load information
              await this.LoadInformationFromId();
              this.router2.navigate(['/projectsale-management']);

            }
          )

      }

    } else {
      //mark FormGroup Touched
      this.GlobalService.validateAllFormFields(this.AssignLeadForm)

    }

  }
  // ----------------------- Function Assign Member Zone -----------------------------------------

  // ----------------------- Function Quotation Setting Zone -------------------------------------
  async LoadProjectSaleQuotaionList() {
    try {
      const auth_token = await this.TokenService.RefreshToken();
      if (!auth_token) {
        console.error('No valid token');
        alert('Session expired. Please login again.');
        return;
      }

      //console.log('this.projectData.ProjectPipelineProjectSaleId', this.projectData.ProjectPipelineProjectSaleId);

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      //const objectjson = {
        //rowFetch: environment.PageSize,
        //rowOFFSet: ((this.currentPageNumber - 1) < 0 ? 0 : (this.currentPageNumber - 1)) * environment.PageSize
      //};

      var objectjson = {};

        objectjson['ProjectSaleID'] = this._ParamProjectSaleID;

      const response = await this.httpClient.post<any>(
        this.baseurl + "ProjectSaleQuotation/GetProjectSaleQuotation",
        JSON.stringify(objectjson),
        httpOptions
      ).toPromise();

      this.ProjectSaleQuotaionList = response;
      //this.totalItems = this.CompanyList.length;

      // if (this.CompanyList.length <= 0) {
      //   this.currentPageNumber = 0;
      // } else {
      //   if (this.currentPageNumber == 0) this.currentPageNumber = 1;
      //   this.totalItems = Number(this.CompanyList[0].itemTotal);
      // }

      // this.totalPages = Math.ceil(this.totalItems / environment.PageSize);

      //console.log('PageSize:', environment.PageSize);
      //console.log('Total Items:', this.totalItems);
      //console.log('Total Pages:', this.totalPages);
      
    } catch (error) {
      console.error('Error loading company group:', error);
      alert('An error occurred while loading company group data. Please try again.');
    } finally {
    }
  }

  displayFieldCssQuotation(field: string) {
    return {
      'has-error': this.isFieldQuotationValid(field),
      'has-feedback': this.isFieldQuotationValid(field)
    };
  }

  isFieldQuotationValid(field: string) {
    return this.formProjectSaleQuotation.get(field)?.invalid && this.formProjectSaleQuotation.get(field)?.touched;
  }

  btnClick_onCreateProjectSaleQuotation() {
    this.isOnUpdateProjectSaleQuotation = false;
    this.InformationForm.get('formProjectSaleQuotation').reset();
    setTimeout(() => {
      this.onPriceBlur();
    }, 0)

    this.InformationForm.get('formProjectSaleQuotation').patchValue({
      quotationType: '1',
      selectActiveFlag: 'Y',
      QuotationNoSelect: ''
    });

    $('#ModalQuotation').modal('show'); //
  }

get formProjectSaleQuotation(): FormGroup {
  return this.InformationForm?.get('formProjectSaleQuotation') as FormGroup;
}

async btnClick_submitInsertProjectSaleQuotation() {
  const quotationType = this.formProjectSaleQuotation.get('quotationType')?.value;
  const txtQuotationNo = this.formProjectSaleQuotation.get('txtQuotationNo')?.value?.trim();
  const selectQuotationNo = this.formProjectSaleQuotation.get('QuotationNoSelect')?.value?.trim();

  const quotationNo = quotationType === '1' ? txtQuotationNo : selectQuotationNo;

  const isDuplicate = this.ProjectSaleQuotaionList.some(
  q => q.ProjectSaleQuotationNo === quotationNo
);

if (isDuplicate) {
  this.duplicateQuotationError = true; // ให้ flag เพื่อ ngIf แสดง error
  return;
} else {
  this.duplicateQuotationError = false;
}


//console.log('txtQuotationNo', this.formProjectSaleQuotation.value.txtQuotationNo)
this.formProjectSaleQuotation.updateValueAndValidity();
    if (this.formProjectSaleQuotation.valid) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        console.log('form submitted');
        //this.OnCreating('y');
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };

        const quotationType = this.formProjectSaleQuotation.get('quotationType')?.value;
        const txtQuotationNo = this.formProjectSaleQuotation.get('txtQuotationNo')?.value?.trim();
        const selectQuotationNo = this.formProjectSaleQuotation.get('QuotationNoSelect')?.value?.trim();
        const rawFormValue = this.formProjectSaleQuotation.getRawValue();

        var objectjson = {};
        objectjson['ProjectSaleID'] = this._ParamProjectSaleID;
        objectjson['ProjectSaleCode'] = this.ProjectPipelineitem.ProjectSaleCode;
        objectjson['ProjectSaleQuotationType'] = quotationType;
        //objectjson['ProjectSaleQuotationNo'] = this.checkUndefinedString(this.formProjectSaleQuotation.value.txtQuotationNo);
        objectjson['ProjectSaleQuotationPrice'] = this.formProjectSaleQuotation.value.txtPrice; // number
        objectjson['ProjectSaleQuotationPrice'] = rawFormValue.txtPrice;
        objectjson['ProjectSaleQuotationActiveFlag'] = this.checkUndefinedString(this.formProjectSaleQuotation.value.selectActiveFlag);
        objectjson['ProjectSaleQuotationCreateBy'] = this.checkUndefinedString(localStorage.getItem("EmpCode"));

        if (quotationType === '1') {
        objectjson['ProjectSaleQuotationNo'] = this.checkUndefinedString(txtQuotationNo);
      } else if (quotationType === '2') {
        objectjson['ProjectSaleQuotationNo'] = this.checkUndefinedString(selectQuotationNo);
      }

        let strjson = JSON.stringify(objectjson);

        this.isSubmitted = this.httpClient.post<ProjectSaleQuotationInfo[]>(this.baseurl + "ProjectSaleQuotation/InsertProjectSaleQuotation", strjson, httpOptions)

          .subscribe(
    // do next callback as async use await
    async (result) => {
      this.isSubmitted = result;

      //console.log("Insert = ", this.isSubmitted);
      if (!!this.projectsaleQuotationFilesToUpload && this.projectsaleQuotationFilesToUpload.length > 0) {
        console.log('projectsaleQuotationFilesToUpload!!', this.projectsaleQuotationFilesToUpload);
              var isUploadSuccess = await this.UploadProjectSaleQuotationAttachedFilesToServer(this.projectsaleQuotationFilesToUpload);
              if (isUploadSuccess) {
                for (const val of this.projectsaleQuotationFilesToUpload) {
                  await this.InsertProjectSaleQuotationAttachedFile(val.name, this.projectsaleQuotationPathFile + "\\" + val.name, this.isSubmitted)
                }
              }

              //$('#ModalProjectSaleBudgetCreateComplete').modal();
              this.IsClearProjectSaleQuotationAttachedmentList = "true";
              this.projectsaleQuotationFilesToUpload = [];
              //this.LoadProjectSaleBudgetAttachedFile(this.isSubmitted);
            }

      $('#ModalQuotation').modal('hide');
      $('#ModalCreateQuotationComplete').modal();

      await this.UpdateProjectSaleActualPriceByQuotation();
      await this.LoadInformationFromId();
      await this.LoadProjectSaleQuotaionList();
      
    },
    (error) => {
      console.error("Insert fail", error);
      alert("Insert failed. Please try again.");
        }
      );
    }

    } else {
      this.validateAllFormFields(this.formProjectSaleQuotation);
    }
  }

  // console.log("Insert = " + this.isSubmitted)
  //             $('#ModalQuotation').modal('hide');
  //             $('#ModalCreateQuotationComplete').modal();
  //             this.LoadInformationFromId();
  //             this.LoadProjectSaleQuotaionList();
  //             this.UpdateProjectSaleActualPriceByQuotation();

validateAllFormFields(formGroup: FormGroup) {
      Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
        this.UpdateProjectSaleActualPriceByQuotation()
      }
    });
  }

  async btnClick_onUpdateProjectSaleQuotation(id) {
    $('#ModalQuotation').modal('hide');
    this.isOnUpdateProjectSaleQuotation = true;
    const index = this.ProjectSaleQuotaionList.findIndex(x => x.ProjectSaleQuotationID === id);

    //console.log('id!!!', id)
    //console.log('index!!!', index)

    this.hidProjectSaleQuotaionID = id; // index for update

  if (index === -1) return;

  const item = this.ProjectSaleQuotaionList[index]; 

  const quotationType = String(item.ProjectSaleQuotationType ?? '1');

  this.formProjectSaleQuotation.patchValue({
    txtQuotationNo: quotationType === '1' ? item.ProjectSaleQuotationNo ?? '' : '',
    QuotationNoSelect: quotationType === '2' ? item.ProjectSaleQuotationNo ?? '' : '',
    //txtPrice: item.ProjectSaleQuotationPrice ?? null,
    selectActiveFlag: item.ProjectSaleQuotationActiveFlag ?? null,
    quotationType: String(item.ProjectSaleQuotationType ?? '1')
  });


  if (quotationType === '2') {
    const quotationNoSelect = this.formProjectSaleQuotation.get('QuotationNoSelect');
    quotationNoSelect.markAsPristine();
    quotationNoSelect.markAsUntouched();
    quotationNoSelect.updateValueAndValidity();
    this.duplicateQuotationError = false;
  } else {
    const txtQuotationNo = this.formProjectSaleQuotation.get('txtQuotationNo');
    txtQuotationNo.markAsPristine();
    txtQuotationNo.markAsUntouched();
    txtQuotationNo.updateValueAndValidity();
    this.duplicateQuotationError = false;
  }



  if (quotationType === '1') {
  this.formProjectSaleQuotation.get('txtPrice')?.setValue(item.ProjectSaleQuotationPrice ?? '');
  this.formProjectSaleQuotation.get('txtPrice')?.enable();
} else {
  // ในกรณี '2' ให้ disable และรอ valueChanges ทำงานเอง
  this.formProjectSaleQuotation.get('txtPrice')?.disable();
}

  setTimeout(() => {
    this.onPriceBlur(); // Format ค่าใน input field
  }, 0);

  await this.LoadProjectSaleQuotationAttachedment(id);

  $('#ModalQuotation').modal('show');
  }

  async btnClick_submitUpdateProjectSaleQuotation(id) {
      this.formProjectSaleQuotation.updateValueAndValidity();

      const selectedType = this.formProjectSaleQuotation.get('quotationType').value;
      const txtQuotationNo = this.formProjectSaleQuotation.get('txtQuotationNo')?.value?.trim();
      const selectQuotationNo = this.formProjectSaleQuotation.get('QuotationNoSelect')?.value?.trim();
      const quotationNo = selectedType === '1' ? txtQuotationNo : selectQuotationNo;

      const found = this.ProjectSaleQuotaionList.find(
        q => q.ProjectSaleQuotationNo === quotationNo
      );

      if (found && found.ProjectSaleQuotationID !== this.hidProjectSaleQuotaionID) {
        this.duplicateQuotationError = true;
        return;
      } else {
        this.duplicateQuotationError = false;
      }

      const txtPriceControl = this.formProjectSaleQuotation.get('txtPrice');
      const price = txtPriceControl.disabled ? txtPriceControl.value : this.formProjectSaleQuotation.value.txtPrice;

      if (this.formProjectSaleQuotation.valid) {
        var auth_token = await this.TokenService.RefreshToken();
        if (!!auth_token) {
          //this.OnUpdating('y');
  
          id = this.hidProjectSaleQuotaionID
          const httpOptions = {
            headers: new HttpHeaders({
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${auth_token}`
  
            })
          };
  
          const quotationType = this.formProjectSaleQuotation.get('quotationType')?.value;

          var objectjson = {};
        objectjson['ProjectSaleQuotationID'] = this.hidProjectSaleQuotaionID;
        objectjson['ProjectSaleQuotationType'] = quotationType;
        //objectjson['ProjectSaleQuotationNo'] = this.checkUndefinedString(quotationNo);
        objectjson['ProjectSaleQuotationPrice'] = price; // number
        objectjson['ProjectSaleQuotationActiveFlag'] = this.checkUndefinedString(this.formProjectSaleQuotation.value.selectActiveFlag);
        objectjson['ProjectSaleQuotationUpdateBy'] = this.checkUndefinedString(localStorage.getItem("EmpCode"));

        if (quotationType === '1') {
          objectjson['ProjectSaleQuotationNo'] = this.checkUndefinedString(txtQuotationNo);
        } else if (quotationType === '2') {
          objectjson['ProjectSaleQuotationNo'] = this.checkUndefinedString(selectQuotationNo);
        }
  
          let strjson = JSON.stringify(objectjson);
  
          this.isSubmitted = this.httpClient.post<ProjectSaleQuotationInfo[]>(this.baseurl + "ProjectSaleQuotation/UpdateProjectSaleQuotation", strjson, httpOptions)
  
            .subscribe(
              async (result) => {
                //this.OnUpdating('n');
                this.isSubmitted = result;
                //console.log('Update =', this.isSubmitted);
                $('#ModalQuotation').modal('hide');
                $('#ModalCreateQuotationComplete').modal();

                if (!!this.projectsaleQuotationFilesToUpload && this.projectsaleQuotationFilesToUpload.length > 0) {
                  //console.log('projectsaleQuotationFilesToUpload!!', this.projectsaleQuotationFilesToUpload);
                  var isUploadSuccess = await this.UploadProjectSaleQuotationAttachedFilesToServer(this.projectsaleQuotationFilesToUpload);
                  if (isUploadSuccess) {
                    for (const val of this.projectsaleQuotationFilesToUpload) {
                      await this.InsertProjectSaleQuotationAttachedFile(val.name, this.projectsaleQuotationPathFile + "\\" + val.name, this.hidProjectSaleQuotaionID)
                  }
                  this.IsClearProjectSaleQuotationAttachedmentList = "true";
                  this.projectsaleQuotationFilesToUpload = [];
                }

              //$('#ModalProjectSaleBudgetCreateComplete').modal();
              
              //this.LoadProjectSaleBudgetAttachedFile(this.isSubmitted);
            }


                await this.UpdateProjectSaleActualPriceByQuotation();
                await this.LoadProjectSaleQuotaionList();
                await this.LoadInformationFromId();
                },
              (error) => {
                console.error('Update fail', error);
                alert('An error occurred while updating the quotation. Please try again.');
              }
            )
          }
      } else {
        this.validateAllFormFields(this.form);
      }
  }

  // console.log("Update = " + this.isSubmitted);
  //               //this.OnUpdating('n');
  //               $('#ModalQuotation').modal('hide');
  //               $('#ModalCreateQuotationComplete').modal();
  //               await this.LoadInformationFromId();
  //               await this.LoadProjectSaleQuotaionList();
  //               await this.UpdateProjectSaleActualPriceByQuotation();

  chkallProjectSaleQuotationclick(target) {
    var check = $(target.currentTarget).is(":checked");

    $('[name="checkboxProjectSaleQuotaion"]').prop('checked', check);
  }

  async btnClick_onDeleteProjectSaleQuotationList() {
  if (confirm("Are you sure to delete this Company Group?")) {
  
        var checkkedcompanygroup = $('[name="checkboxProjectSaleQuotaion"]:checked');
        let num = checkkedcompanygroup.length;
        let listCompanyGroupModel = [];
        
  
        for (var i = 0; i < num; i++) {
          var CompanyGroupcurrent = <HTMLInputElement>checkkedcompanygroup[i];
          let companygroupInfo = new ProjectSaleQuotationInfo;
          companygroupInfo.ProjectSaleQuotationID = parseInt(CompanyGroupcurrent.value);
  
            var currentCompanyGroup = this.ProjectSaleQuotaionList.filter(x => { return x.ProjectSaleQuotationID == companygroupInfo.ProjectSaleQuotationID });
            var isOwner = (currentCompanyGroup[0].ProjectSaleQuotationCreateBy == this._EmpCode);
  
            console.log(" Delete id = " + companygroupInfo.ProjectSaleQuotationID + " \n Role = " + this._RoleCode + " \n Is Owner? = " + isOwner);
            if (isOwner || (this._RoleCode != "")) {
              listCompanyGroupModel.push(companygroupInfo);
            } else
            {
              //this.titlemodal = ""
              //this.detailmodal = "Cannot delete company : <b>" + currentCompany[0].CompanyName + "</b>. please contact " + currentCompany[0].CompanyCreateByDisplay;
              this.detailmodal = "You don't have permission to delete this company. Please contact" + currentCompanyGroup[0].ProjectSaleQuotationCreateBy;
              $('#ModalError .modal-header').text("Information");
              $('#ModalError .modal-header').addClass('bg-blue');
              $('#ModalError').modal();
  
              listCompanyGroupModel = [];
              break; //break loop
            }
        }
  
        if (listCompanyGroupModel.length > 0) {
          this.deleteListProjectSaleQuotation(listCompanyGroupModel)
        }
  
      }
  }

  async deleteListProjectSaleQuotation(listProjectSaleQuotation) {
  console.log('Prepare Delete333', this.deleteListProjectSaleQuotation);
  const auth_token = await this.TokenService.RefreshToken();

  if (!!auth_token) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    const strjsonCusInfo = JSON.stringify(listProjectSaleQuotation);

    try {
      await this.httpClient
        .post<ProjectSaleQuotationInfo[]>(
          this.baseurl + "ProjectSaleQuotation/DeleteListProjectSaleQuotation",
          strjsonCusInfo,
          httpOptions
        )
        .toPromise();

      console.log("delete quotation list successfully");
      $('#ModalDeleteComplete').modal('show');

      await this.UpdateProjectSaleActualPriceByQuotation();
      await this.LoadInformationFromId();
      await this.LoadProjectSaleQuotaionList();
    } catch (err) {
      console.log(err);
    }
  }
}


    async UpdateProjectSaleActualPriceByQuotation() {
    if (this.formProjectSaleQuotation.valid) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      console.log('UpdateProjectSaleActualPriceByQuotation: form submitted');
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['ProjectSaleID'] = this._ParamProjectSaleID;
      objectjson['ProjectSaleQuotationUpdateBy'] = this.checkUndefinedString(localStorage.getItem("EmpCode"));

      let strjson = JSON.stringify(objectjson);

      try {
        // <<-- จุดสำคัญของการแก้ไข: เปลี่ยนจาก .subscribe เป็น .toPromise() หรือ firstValueFrom() แล้ว await -->>

        // หากใช้ Angular เวอร์ชั่นเก่า (<17) ใช้ .toPromise()
        const result = await this.httpClient.post<ProjectSaleQuotationInfo[]>(
          this.baseurl + "ProjectSaleQuotation/UpdateProjectSaleActualPriceByQuotation",
          strjson,
          httpOptions
        ).toPromise(); // ทำให้ Observable กลายเป็น Promise ที่ await ได้

        // หากใช้ Angular เวอร์ชั่นใหม่ (17+) ใช้ firstValueFrom()
        // const result = await firstValueFrom(this.httpClient.post<ProjectSaleQuotationInfo[]>(
        //   this.baseurl + "ProjectSaleQuotation/UpdateProjectSaleActualPriceByQuotation",
        //   strjson,
        //   httpOptions
        // ));

        this.isSubmitted = result;
        console.log("Update = " + this.isSubmitted);
        return result;
      } catch (error) {
        console.error("Update fail", error);
        alert("Update failed. Please try again.");
        throw error;
      }
    } else {
      console.warn("Auth token not available for UpdateProjectSaleActualPriceByQuotation.");
      throw new Error("Authentication token not available."); // หรือจัดการ Error ตามความเหมาะสม
    }
  } else {
    this.validateAllFormFields(this.formProjectSaleQuotation);
    console.warn("Form is not valid in UpdateProjectSaleActualPriceByQuotation.");
    throw new Error("Form validation failed."); // หรือจัดการ Error ตามความเหมาะสม
  }
  }

  OnBtnBack_Click() {
    this.router2.navigate(["/projectsale-management"]);
  }

  formatPrice(value: number | string | null | undefined): string {
  if (value == null || value === '') return '';
  
  // remove comma before set number format
  const cleanedValue = String(value).replace(/,/g, '');
  const num = parseFloat(cleanedValue);
  
  if (isNaN(num)) {
    return '';
  }
  
  // use toLocaleString set minimum/maximumFractionDigits is 2
  return num.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
}

onPriceFocus() {
  const inputElement = document.getElementById('txtPrice') as HTMLInputElement;
  if (inputElement) {
    // remove formatting focus
    const currentValue = inputElement.value;
    if (currentValue) {
      const cleanValue = currentValue.replace(/,/g, '');
      inputElement.value = cleanValue;
    }
  }
}

onPriceInput(event: Event) {
  const input = event.target as HTMLInputElement;
  let rawValue = input.value;
  
  // set cleanvalue: remove not contains comma & decimal
  let cleanValue = rawValue.replace(/[^0-9.]/g, '');
  
  // validate keep only first . position
  const parts = cleanValue.split('.');
  if (parts.length > 2) {
    cleanValue = parts[0] + '.' + parts.slice(1).join('');
  }
  
  // limit 2 decimal format
  if (parts.length === 2 && parts[1].length > 2) {
    cleanValue = parts[0] + '.' + parts[1].substring(0, 2);
  }
  
  // update input value match clean value
  input.value = cleanValue;
  
  // transform real number format FormControl
  const num = parseFloat(cleanValue);
  
  // update FormControl to Number
  this.formProjectSaleQuotation.get('txtPrice')?.setValue(
    isNaN(num) ? null : num, 
    { emitEvent: false }
  );
}

onPriceBlur() {
  const control = this.formProjectSaleQuotation.get('txtPrice');
  const numericValue = control?.value;
  
  const inputElement = document.getElementById('txtPrice') as HTMLInputElement;
  
  if (inputElement) {
    if (numericValue != null && numericValue !== '') {
      const formatted = this.formatPrice(numericValue);
      inputElement.value = formatted;
    } else {
      inputElement.value = '';
    }
  }
}

clearForm() {
  this.formProjectSaleQuotation.reset();
  const inputElement = document.getElementById('txtPrice') as HTMLInputElement;
  if (inputElement) {
    inputElement.value = '';
  }
}

updateQuotationTypeValidation(type: string): void {
  const txtQuotationNo = this.formProjectSaleQuotation.get('txtQuotationNo');
  const quotationNoSelect = this.formProjectSaleQuotation.get('QuotationNoSelect');
  const txtPrice = this.formProjectSaleQuotation.get('txtPrice');

  if (type === '1') {
    // Manual Quotation: use only txtQuotationNo 
    txtQuotationNo.setValidators([Validators.required]);
    quotationNoSelect.clearValidators();
    quotationNoSelect.setValue('');
    txtPrice.enable();
    txtPrice.setValue('');
  } else if (type === '2') {
    // Quotation List: use only QuotationNoSelect
    quotationNoSelect.setValidators([Validators.required]);
    txtQuotationNo.clearValidators();
    txtQuotationNo.setValue('');
    txtPrice.disable();
  }

  txtQuotationNo.updateValueAndValidity();
  quotationNoSelect.updateValueAndValidity();
  txtPrice.updateValueAndValidity();
}

async LoadQuotationList() {
    try {
      const auth_token = await this.TokenService.RefreshToken();
      if (!auth_token) {
        console.error('No valid token');
        alert('Session expired. Please login again.');
        return;
      }

      //console.log('this.projectData.ProjectPipelineProjectSaleId', this.projectData.ProjectPipelineProjectSaleId);

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      //const objectjson = {
        //rowFetch: environment.PageSize,
        //rowOFFSet: ((this.currentPageNumber - 1) < 0 ? 0 : (this.currentPageNumber - 1)) * environment.PageSize
      //};

      var objectjson = {};

        objectjson['QuotationProjectSaleID'] = this._ParamProjectSaleID;

      const response = await this.httpClient.post<any>(
        this.baseurl + "Quotation/GetQuotation",
        JSON.stringify(objectjson),
        httpOptions
      ).toPromise();

      this.QuotationList = response;
      //this.totalItems = this.CompanyList.length;

      // if (this.CompanyList.length <= 0) {
      //   this.currentPageNumber = 0;
      // } else {
      //   if (this.currentPageNumber == 0) this.currentPageNumber = 1;
      //   this.totalItems = Number(this.CompanyList[0].itemTotal);
      // }

      // this.totalPages = Math.ceil(this.totalItems / environment.PageSize);

      //console.log('PageSize:', environment.PageSize);
      //console.log('Total Items:', this.totalItems);
      //console.log('Total Pages:', this.totalPages);
      
    } catch (error) {
      console.error('Error loading company group:', error);
      alert('An error occurred while loading company group data. Please try again.');
    } finally {
    }
  }

async LoadQuotationProductList(id: number): Promise<any[]> {
   try {
      const auth_token = await this.TokenService.RefreshToken();
      if (!auth_token) {
        console.error('No valid token');
        alert('Session expired. Please login again.');
        return;
      }

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

        objectjson['QuotationID'] = id;

      const response = await this.httpClient.post<any>(this.baseurl + "Quotation/GetQuotationProduct", JSON.stringify(objectjson),
        httpOptions).toPromise();

      this.QuotationProductList = response;
      return this.QuotationProductList;
    } catch (error) {
      console.error('Error loading company group:', error);
      alert('An error occurred while loading company group data. Please try again.');
    } finally {
    }
}

DragFilesProjectQuotationAttachedmentFinished(returnObj) {
if (!!returnObj.Message) {
      alert(returnObj.Message)
    } else {
      this.projectsaleQuotationFilesToUpload = returnObj.Files;
      this.projectsaleQuotationPathFile = returnObj.PathFile;
    }
  }

  async UploadProjectSaleQuotationAttachedFilesToServer(files) {

    if (!files || files.length === 0) {
      alert("Please browse file at least one.")
      return false;
    }
    let filesToUpload: File[] = files;

    await Array.from(filesToUpload).map((file, index) => {
      // push uoload list
      const formData = new FormData();
      formData.append("pathfile", this.projectsaleQuotationPathFile);
      formData.append('file' + index, file, file.name);
      this.httpClient.post(this.baseurl + "api/upload", formData, { reportProgress: true, observe: 'events' })
        .subscribe(event => {
          if (event.type === HttpEventType.UploadProgress) {
            var progress = Math.round(100 * event.loaded / event.total);

            if (progress == 100) {
            }

          } else if (event.type === HttpEventType.Response) {
          }
        });



    });

    return true;
  }

  async InsertProjectSaleQuotationAttachedFile(Filename, pathfile, projectsalequotationid) {
    console.log('call insert attachment', Filename, pathfile, projectsalequotationid);
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      console.log('call insert attachment true', Filename, pathfile, projectsalequotationid);

      var objectjson = {};
      objectjson['ProjectSaleQuotationID'] = projectsalequotationid;
      objectjson['ProjectSaleQuotationAttachmentFileName'] = Filename;
      objectjson['ProjectSaleQuotationAttachmentPathFile'] = pathfile;
      objectjson['ProjectSaleQuotationAttachmentFlagDelete'] = "N";
      objectjson['ProjectSaleQuotationAttachmentCreateBy'] = localStorage.getItem("EmpCode");




      let strjson = JSON.stringify(objectjson);

      console.log('strjson attach quotation', strjson);

      this.isProjectSaleQuotationAttachedmentSubmitted = this.httpClient.post<ProjectSaleQuotationAttachmentInfo[]>(this.baseurl + "ProjectSaleQuotation/InsertProjectSaleQuotationAttachedFile", strjson, httpOptions)

        .subscribe(result => this.isProjectSaleQuotationAttachedmentSubmitted = result, failCb => {
          console.log("Insert fail")
        },
          () => {
            console.log("Insert = " + this.isProjectSaleQuotationAttachedmentSubmitted)
          }
        )
    }
  }

  async LoadProjectSaleQuotationAttachedment(projectsalequotationid) {
    var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        await this.LoadProjectSaleQuotationAttachedmentList(projectsalequotationid, auth_token)
          .then(data => {
            this.ProjectSaleQuotationAttachedmentList = data;
          })
        .catch(error => {
      console.error('There was an error!', error);
      });
    }
  }

  async LoadProjectSaleQuotationAttachedmentList(projectsalequotationid, auth_token): Promise<ProjectSaleQuotationAttachmentInfo[]> {

  const httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${auth_token}`
    })
  };

  var objectjson = {};

  objectjson['ProjectSaleQuotationID'] = projectsalequotationid;

  let strjson = JSON.stringify(objectjson);

  return this.httpClient
    .post<ProjectSaleQuotationAttachmentInfo[]>(this.baseurl + "ProjectSaleQuotation/GetProjectSaleQuotationAttachment",
      strjson, httpOptions)
    .toPromise(); // Convert the Observable to a Promise
  }

  OnDeleteProjectSaleQuotationAttachedmentClick(elem) {
    let dataInfo = $(elem).parent().data();
    if (Object.keys(dataInfo).length > 0) {
      //Confirm to delete
      this.modalDocInfo = dataInfo;
      this.modalDocName = dataInfo.documentname;
      $('#ModalConfirmDeleteProjectSaleQuotationAttachedFile').modal();
    }
  }

  async DeleteProjectSaleQuotationAttachedFile() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['ProjectSaleQuotationAttachmentID'] = this.modalDocInfo.documentid;

      let strjson = JSON.stringify(objectjson);
      this.httpClient
        .post<boolean>(this.baseurl + "ProjectSaleQuotation/DeleteProjectSaleQuotationAttachedFile",
          strjson, httpOptions)
        .subscribe({
          next: data => {
            if (data) {
              this.titlemodal = "Success";
              this.detailmodal = "The attached file has been deleted."
              this.LoadProjectSaleQuotaionList();
              this.LoadProjectSaleQuotationAttachedment(this.modalDocInfo.projectsalequotationid);
            } else {
              this.titlemodal = "Sorry";
              this.detailmodal = "Delete fail."
            }
          },
          error: error => {
            console.error('There was an error!', error);
          }
        });
    }
  }

  async btn_LoadProjectSaleQuotationAttachedFile(id: any) {
  try {
    const auth_token = await this.TokenService.RefreshToken();
    if (auth_token) {
      const data = await this.LoadProjectSaleQuotationAttachedmentList(id, auth_token);
      this.ProjectSaleQuotationAttachedmentList = data;
      $('#modalProjectSaleQuotationAttachedFile').modal('show');
    }
  } catch (error) {
    console.error('There was an error!', error);
    // สามารถเพิ่มโค้ดแจ้งเตือนผู้ใช้ในส่วนนี้ได้
  }
}

  async SubmitCloseDealSuspend() {
    if (confirm("Are you sure to suspend this Project?")) {
      if (this.InformationForm.get('CloseDealForm').valid && this.CloseDealSubState != '') {
      $('#confirmselectedstatus').modal('hide');
      $('#confirmclosedeal').modal('hide');

      this.loading(true, 'Saving ...');

      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };

        var objectjson = {};
        objectjson['ProjectSaleId'] = this._ParamProjectSaleID;
        //objectjson['ProjectSaleCode'] = this.ProjectSaleCode;
        //objectjson['ProjectSaleState'] = '1-5'; // Request for close deal
        //objectjson['ProjectSaleSubState'] = this.CloseDealSubState;
        //objectjson['ProjectSaleCloseDealProgress'] = '4'; // close deal
        //objectjson['ProjectSaleEffortGroupId'] = this.InformationForm.get('CloseDealForm').get('EffortGroup').value; // close deal
        objectjson['ProjectSaleUpdateBy'] = this.GlobalService.checkUndefinedString(localStorage.getItem("EmpCode"));
        objectjson['ProjectSaleCloseDealComment'] = this.InformationForm.get('CloseDealForm').get('Comment')?.value;

        let strjson = JSON.stringify(objectjson);

        this.isSubmitted = this.httpClient.post<ProjectSaleInfo[]>(this.baseurl + "ProjectSale/SuspendProjectSale", strjson, httpOptions)

          .subscribe(result => this.isSubmitted = result, failCb => {
            console.log("Update fail");
            this.loading(false);

            this.titlemodal = 'Submit Suspend fail.';
            this.detailmodal = 'Your information was submit fail.';



            $('#ModalError').modal();

          },
            () => {
              console.log("Update = " + this.isSubmitted);
              this.loading(false);
              this.titlemodal = 'Submit Suspend success.';
              this.detailmodal = 'Your Suspend has been submited.';

              $('#ModalComplate').modal();

              // when select close deal
              if (this.confirmselectedstatuscode == '4') {
                // update request type
                this.hideProjectSaleRequestType = '2';
              } else {
                // update progress
                this.ProjectSaleCloseDealProgress = this.confirmselectedstatuscode;

              }
              setTimeout(() => {
                // Do something after 2 seconds
                this.router2.navigateByUrl('/projectsale-management');
              }, 2000);


            }

          )

      }
      } else {
      if (this.CloseDealSubState == '') {
        this.CloseDealWarning = 'Please select closing type before action submit close deal.'
      }
      this.GlobalService.validateAllFormFields(this.InformationForm.get('CloseDealForm') as FormGroup);
    }
    }
  }

  async SubmitCloseDealTerminate() {
    //console.log('SubmitCloseDealTerminate Clicked');

    if (confirm("Are you sure to Terminate this Project?")) {
    if (this.InformationForm.get('CloseDealForm').valid && this.CloseDealSubState != '') {
      $('#confirmselectedstatus').modal('hide');
      $('#confirmclosedeal').modal('hide');

      this.loading(true, 'Saving ...');

      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };

        var objectjson = {};
        objectjson['ProjectSaleId'] = this._ParamProjectSaleID;
        //objectjson['ProjectSaleCode'] = this.ProjectSaleCode;
        //objectjson['ProjectSaleState'] = '1-5'; // Request for close deal
        //objectjson['ProjectSaleSubState'] = this.CloseDealSubState;
        //objectjson['ProjectSaleCloseDealProgress'] = '4'; // close deal
        //objectjson['ProjectSaleEffortGroupId'] = this.InformationForm.get('CloseDealForm').get('EffortGroup').value; // close deal
        objectjson['ProjectSaleUpdateBy'] = this.GlobalService.checkUndefinedString(localStorage.getItem("EmpCode"));
        objectjson['ProjectSaleCloseDealComment'] = this.InformationForm.get('CloseDealForm').get('Comment')?.value;

        let strjson = JSON.stringify(objectjson);

        this.isSubmitted = this.httpClient.post<ProjectSaleInfo[]>(this.baseurl + "ProjectSale/TerminateProjectSale", strjson, httpOptions)

          .subscribe(result => this.isSubmitted = result, failCb => {
            console.log("Update fail");
            this.loading(false);

            this.titlemodal = 'Submit Terminate fail.';
            this.detailmodal = 'Your terminate was submit fail.';



            $('#ModalError').modal();

          },
            () => {
              console.log("Update = " + this.isSubmitted);
              this.loading(false);
              this.titlemodal = 'Submit Terminate success.';
              this.detailmodal = 'Your Terminate has been submited.';

              $('#ModalComplate').modal();

              // when select close deal
              if (this.confirmselectedstatuscode == '4') {
                // update request type
                this.hideProjectSaleRequestType = '2';
              } else {
                // update progress
                this.ProjectSaleCloseDealProgress = this.confirmselectedstatuscode;

              }
              setTimeout(() => {
                // Do something after 2 seconds
                this.router2.navigateByUrl('/projectsale-management');
              }, 2000);


            }

          )

      }
      } else {
      if (this.CloseDealSubState == '') {
        this.CloseDealWarning = 'Please select closing type before action submit close deal.'
      }
      this.GlobalService.validateAllFormFields(this.InformationForm.get('CloseDealForm') as FormGroup);
      }
    }
  }

  async CheckPipelineStatusBeforeCloseDeal(projectsaleCode: string) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['ProjectSaleCode'] = this.checkUndefinedString(projectsaleCode);

      let strjson = JSON.stringify(objectjson);

      this.ProjectPipeLineQuoStatusList = await this.httpClient.post<ProjectPipelineInfo[]>(this.baseurl + "ProjectPipeline/GetPipelineStatusQuotation", strjson, httpOptions)
        .toPromise()
        
      console.log("Pipeline Quotation Status List =>", this.ProjectPipeLineQuoStatusList);
    }
  }

}
